import { statusLegadoClass } from '../../shared/status-legado';
import { codVendCompradorDoUsuario } from '../../shared/comprador-por-usuario';
import { LoadingIndicatorComponent } from '../../components/loading-indicator/loading-indicator.component';
import * as XLSX from 'xlsx';
// @ts-ignore
import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, signal, HostListener } from '@angular/core';
// @ts-ignore
import { CommonModule } from '@angular/common';
// @ts-ignore
import { FormsModule } from '@angular/forms';
import { firstValueFrom, Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, timeout } from 'rxjs/operators';
import { SankhyaGatewayService, DemonstrativoCotacao } from '../../services/sankhya-gateway.service';
import { EmpresaStateService } from '../../services/empresa-state.service';
import { ProdutoService } from '../../services/produto.service';
import { ordenarSugestoesParceiro } from '../../shared/ordenar-sugestoes-parceiro';

// ── Interfaces ─────────────────────────────────────────────────────────────

interface FornecedorSugestao {
  codparc:      string | number;
  nomeparc:     string;
  docparc?:     string;
  inscEstadual?: string;
  cidade?:      string;
  uf?:          string;
}

interface VendedorOpcao {
  codVend: string | number;
  apelido: string;
}

interface OpcaoCampo {
  valor: string;
  opcao: string;
}

interface ItemCompra {
  id:              number;
  codprod:         string;
  codprodOriginal?: string;
  codprodInterno?: number;
  codlocalpadrao?: number;
  localSel?: number;
  /** 'RECENTE' (padrão) = entrada mais recente; 'FIFO' = entrada mais antiga com saldo. */
  localOrdem?: 'RECENTE' | 'FIFO';
  locaisOpcoes?: { codLocal: number; descrLocal: string; estoque: number; dtEntrada: string }[];
  localAerosys?: string;
  descricao:       string;
  unidade:         string;
  quantidade:      number;
  precoUsd:        number;
  precoUnitario:   number;
  desconto:        number;
  vlrDesc:         number;
  vlrAcrescDesc:   number;
  total:           number;
  totalUsd:        number;
  estoque:         number;
  precoUsdStr?:    string;
  /** Fabricante nacional (CODMARCA em FABNAC, igual à Venda): o Preço do
   *  Fabricante vem em R$ -- R$ é o campo mestre e o U$ = R$ ÷ cotação. */
  fabricanteNacional?: boolean;
  /** Linha marcada (checkbox) para as "Ações do Item" (Cancelar/Desmembrar). */
  sel?:            boolean;
  /** Observação do item (TGFITE.GPL_OBSITEM no Sankhya / PRI_OBS no Aerosys). */
  obs?:            string;
  precoBrlStr?:    string;
  buscando?:       boolean;
  /** Status do item (Aberto/Cancelado/Comprado/Parcial) -- só leitura por
   *  enquanto, gravado automaticamente como ABERTO na criação (ver
   *  GPL_STATUSITEM em TGFITE/ItemDaNota.xml). A transição de status
   *  (disparada pela Pré-Compra) e o Cancelado manual são etapas futuras. */
  statusItem?:     'ABERTO' | 'CANCELADO' | 'COMPRADO' | 'PARCIAL';
  /** ID do item correlato no Aerosys (PEDIDO_COMPRA_ITENS.PRI_ID), gravado
   *  automaticamente na criação (ver GPL_IDITEMAEROSYS em TGFITE). Precisa
   *  ir e voltar no payload pra sincronização de edição (ver
   *  sincronizarEdicaoNoAerosys no backend) continuar funcionando numa
   *  segunda edição do mesmo pedido. */
  idItemAerosys?:  number;

  // ── Painel "Peças com Venda nos últimos X meses" (Aerosys + Sankhya) ──
  cd?:                 string;
  custoAnalitico?:     number | null;
  fabricante?:         string;
  pontoPedido?:        number | null;
  estoqueEua?:         number | null;
  qtdeVendas?:         number | null;
  qtdeVendasAnoAnt?:   number | null;
  qtdePedidoOutros?:   number | null;
  pedidoOutros?:       string;
  qtdePrecompraAbBk?:  number | null;
  dataPrecompraAbBk?:  string;
}

/** Uma linha lida do Excel para importação de itens. */
interface ExcelImportRow {
  pn:             string;
  quantidade:     number;
  status:         'pendente' | 'encontrado' | 'nao_encontrado';
  descricao?:     string;
  codprodInterno?: number;
  codlocalpadrao?: number;
  localSel?: number;
  /** 'RECENTE' (padrão) = entrada mais recente; 'FIFO' = entrada mais antiga com saldo. */
  localOrdem?: 'RECENTE' | 'FIFO';
  locaisOpcoes?: { codLocal: number; descrLocal: string; estoque: number; dtEntrada: string }[];
  localAerosys?: string;
  prodData?:      any;
  proximosData?:  any[];
}

// @ts-ignore
@Component({
  selector: 'app-pedido-compra-form',
  standalone: true,
  imports: [LoadingIndicatorComponent, CommonModule, FormsModule],
  templateUrl: './pedido-compra-form.component.html',
  styleUrls: [
    '../../shared/styles/pedido-form-shared.css',
    '../../shared/styles/busca-pecas-shared.css',
    './pedido-compra-form.component.css',
  ],
})
export class PedidoCompraFormComponent implements OnInit, OnDestroy {
  readonly statusLegadoClass = statusLegadoClass;

  // ── Modo edição ─────────────────────────────────────────────
  @Input()  nunotaEditar: number | null = null;
  @Output() voltarLista  = new EventEmitter<void>();

  modoEdicao       = false;
  nunotaAtual: number | null = null;
  carregandoEdicao = false;

  /** A pedido do usuário (2026-08-27): esconde, por enquanto, as colunas
   *  financeiras (Descrição/Preço U$/Preço R$/Desc%/Total R$) e a linha de
   *  TOTAL DO PEDIDO na grade de Itens do Pedido de Compra -- não é usado
   *  nesse fluxo no momento. Fica atrás de uma flag (em vez de apagar) pra
   *  ser fácil trazer de volta se precisar. */
  exibirColunasPreco = true;

  // ── Estado geral ────────────────────────────────────────────
  salvando     = signal(false);
  alerta: { mensagem: string; tipo: 'sucesso' | 'erro' | 'aviso' } | null = null;

  // ── Tabs ────────────────────────────────────────────────────
  abaAtiva: 'dados' | 'itens' = 'dados';

  /** Avisa o gateway quando a aba Itens abre/fecha (ele recolhe o menu lateral). */
  @Output() abaItensChange = new EventEmitter<boolean>();

  mudarAba(aba: 'dados' | 'itens'): void {
    this.abaAtiva = aba;
    this.abaItensChange.emit(aba === 'itens');
    if (aba === 'itens') {
      // Foco no PN da primeira linha ainda vazia (ou na primeira, se todas preenchidas).
      setTimeout(() => {
        const pns = Array.from(document.querySelectorAll<HTMLInputElement>('.pcf-cell-pn'));
        (pns.find(i => !i.value && !i.disabled) ?? pns[0])?.focus();
      }, 80);
    }
  }

  ngOnDestroy(): void {
    this._subEmpresaMudou?.unsubscribe();
    this.abaItensChange.emit(false);
  }

  // ── Confirmação de saída (mesmo padrão do Pedido de Venda) ──────────────
  confirmacaoSairAberta = false;
  private _aoConfirmarSaida: (() => void) | null = null;

  onVoltarClick(): void {
    this.confirmacaoSairAberta = true;
  }

  /** Chamado pelo gateway ao clicar em outro item do menu. Retorna false
   *  (navegação aguarda a confirmação do modal). */
  solicitarSaida(aoConfirmar: () => void): boolean {
    this._aoConfirmarSaida = aoConfirmar;
    this.confirmacaoSairAberta = true;
    return false;
  }

  confirmarSair(): void {
    this.confirmacaoSairAberta = false;
    if (this._aoConfirmarSaida) {
      const cb = this._aoConfirmarSaida;
      this._aoConfirmarSaida = null;
      cb();
    } else {
      this.voltarLista.emit();
    }
  }

  cancelarSair(): void {
    this.confirmacaoSairAberta = false;
    this._aoConfirmarSaida = null;
  }

  // ── Helpers expostos ao template ────────────────────────────
  readonly String = String;

  // ── TOP fixo ────────────────────────────────────────────────
  // TOP 1300 = Pedido de Compra (nativa Sankhya) -- usada tanto pro pedido
  // "avulso" (esta tela) quanto pro gerado a partir de uma Venda (ver
  // PedidoVendaRepository.GERAR_COMPRA_COD_TIP_OPER no addon), já que é o
  // mesmo tipo de documento, só com origem diferente. TOP 1301 é a TOP da
  // Pré-Compra (tela separada, pre-compra-form) -- não usar aqui.
  // Agora depende do TIPO (GPL_TIPO): IMPORTAÇÃO = 1323, NACIONAL = 1300.
  get COD_TIP_OPER(): number {
    return this.tipoGpl === 'NACIONAL' ? 1300 : 1323;
  }
  /** Nome real da TOP (TGFTOP.DESCROPER), carregado em ngOnInit -- evita
   *  texto fixo no front que fica desatualizado se a TOP for renomeada ou
   *  reatribuída. 'Compra' é só o fallback enquanto carrega/se falhar. */
  descricaoTop = 'Compra';

  // ── Cabeçalho ───────────────────────────────────────────────
  dataEmissao   = '';
  dtPrevent     = '';
  observacao    = '';          // TGFCAB.OBSERVACAO ("Observação do Comprador")
  observacaoInterna = '';      // TGFCAB.AD_OBSINT ("Observação Interna")
  numPedido2    = '';
  /** GPL_STATUS (espelho do status no Aerosys) -- só existe depois de salvo,
   *  carregado em carregarParaEdicao. Somente leitura na tela. */
  gplStatusAtual = '';
  /** ID do vinculo com o Aerosys (TGFCAB.GPL_PCRIDAEROSYS): PCR_ID no Pedido de Compra, PCP_ID na Pre-Compra. */
  vinculoAerosysId = 0;
  /** Pedido fora de ABERTO (AUTORIZADO, CANCELADO, PARCIAL, COMPRADO...) abre só para visualização. */
  get somenteLeitura(): boolean {
    const st = (this.gplStatusAtual || '').trim().toUpperCase();
    return this.modoEdicao && !!st && st !== 'ABERTO' && st !== 'TESTE';
  }

  // ── Fornecedor (CODPARC) ────────────────────────────────────
  fornecedorBusca           = '';
  fornecedorSelecionado: FornecedorSugestao | null = null;
  fornecedorSugestoes: FornecedorSugestao[] = [];
  fornecedorCarregando      = false;
  mostrarDropdownFornecedor = false;
  private _fornecedorTimer: any = null;
  private _fornecedorAnterior: FornecedorSugestao | null = null;

  // Modal de fornecedor (lupa)
  fornecedorModalAberta  = false;
  filtroFornecedorModal  = '';
  fornecedorModalLista: FornecedorSugestao[] = [];
  fornecedorModalCarregando = false;
  private _fornecedorModalTimer: any = null;

  // ── Títulos flutuantes do Fornecedor (canvas) ────────────────
  titulosFornecedorPosicionados: { label: string; left: number }[] = [];
  private readonly FORNEC_INPUT_TEXT_START_PX = 34;
  private readonly FORNEC_INPUT_FONT = '400 13px "Segoe UI", Roboto, Arial, sans-serif';
  private _fornecCanvasCtx: CanvasRenderingContext2D | null = null;

  // ── Comprador (CODVEND) ─────────────────────────────────────
  compradores: VendedorOpcao[] = [];
  compradorSelecionado: string | number | null = null;
  compradorModalAberta   = false;
  filtroComprador        = '';

  // ── Prioridade (GPL_PRIORIDADE) ──────────────────────────────
  prioridadeSelecionada = 'NORMAL';
  readonly opcoesPrioridade = ['AOG', 'MESA', 'URGENTE', 'NORMAL'];

  /** GPL_TIPO (TGFCAB) -- NACIONAL ou IMPORTAÇÃO. Padrão IMPORTAÇÃO, que é a
   *  realidade da maioria das compras da empresa. */
  tipoGpl = 'IMPORTACAO';
  tipoGplOpcoes: OpcaoCampo[] = [];

  get compradoresFiltrados(): VendedorOpcao[] {
    const f = this.filtroComprador.trim().toUpperCase();
    return f ? this.compradores.filter(v => (v.apelido || '').toUpperCase().includes(f)) : this.compradores;
  }

  descricaoComprador(codigo: string | number | null): string {
    const c = String(codigo ?? '').trim();
    return this.compradores.find(v => String(v.codVend) === c)?.apelido ?? '';
  }

  valorExibidoComprador(codigo: string | number | null): string {
    const c    = String(codigo ?? '').trim();
    const desc = this.descricaoComprador(c);
    return desc ? `${c} - ${desc}` : c;
  }

  onInputComprador(event: Event): void {
    const input = event.target as HTMLInputElement;
    const val   = input.value;
    const cur   = input.selectionStart ?? val.length;
    const idx   = val.indexOf(' - ');
    const cod   = idx >= 0 ? val.substring(0, idx) : val;
    this.compradorSelecionado = cod;
    const novo  = this.valorExibidoComprador(cod);
    setTimeout(() => {
      input.value = novo;
      const pos   = Math.min(cur, cod.length);
      input.setSelectionRange(pos, pos);
    });
  }

  // ── Tipo Negociação (CODTIPVENDA) ───────────────────────────
  tiposNegociacao: { codTipVenda: string | number; descricao: string }[] = [
    { codTipVenda: '1', descricao: 'A VISTA DINHEIRO' },
  ];
  tipoNegociacaoSelecionado: string | number = '3';
  tipoNegociacaoModalAberta  = false;
  filtroTipoNegociacao       = '';
  tiposNegociacaoCarregando  = false;

  get tiposNegociacaoFiltrados() {
    const f = this.filtroTipoNegociacao.trim().toUpperCase();
    return f
      ? this.tiposNegociacao.filter(t => (t.descricao || '').toUpperCase().includes(f))
      : this.tiposNegociacao;
  }

  descricaoTipoNegociacao(cod: string | number): string {
    return this.tiposNegociacao.find(t => String(t.codTipVenda) === String(cod))?.descricao ?? '';
  }

  valorExibidoTipoNegociacao(cod: string | number): string {
    const desc = this.descricaoTipoNegociacao(cod);
    return desc ? `${cod} - ${desc}` : String(cod);
  }

  // ── Natureza (CODNAT) ────────────────────────────────────────
  naturezas: { codNat: string | number; descricao: string }[] = [
    { codNat: '0', descricao: 'Nenhuma' },
  ];
  // Default 3010101 - PRODUTOS DE REVENDA (pedido do usuário, pra agilizar
  // o preenchimento -- ainda pode ser trocado manualmente).
  naturezaSelecionada: string | number = '3010101';
  naturezaModalAberta  = false;
  filtroNatureza       = '';
  naturezasCarregando  = false;

  get naturezasFiltradas() {
    const f = this.filtroNatureza.trim().toUpperCase();
    return f
      ? this.naturezas.filter(n => (n.descricao || '').toUpperCase().includes(f) || String(n.codNat).includes(f))
      : this.naturezas;
  }

  descricaoNatureza(cod: string | number): string {
    return this.naturezas.find(n => String(n.codNat) === String(cod))?.descricao ?? '';
  }

  valorExibidoNatureza(cod: string | number): string {
    const desc = this.descricaoNatureza(cod);
    return desc ? `${cod} - ${desc}` : String(cod ?? '');
  }

  onInputNatureza(event: Event): void {
    const input = event.target as HTMLInputElement;
    const val   = input.value;
    const cur   = input.selectionStart ?? val.length;
    const idx   = val.indexOf(' - ');
    const cod   = idx >= 0 ? val.substring(0, idx) : val;
    this.naturezaSelecionada = cod;
    const novo = this.valorExibidoNatureza(cod);
    setTimeout(() => {
      input.value = novo;
      const pos = Math.min(cur, cod.length);
      input.setSelectionRange(pos, pos);
    });
  }

  abrirBuscaNatureza(): void {
    this.filtroNatureza  = '';
    this.naturezaModalAberta = true;
    this._carregarNaturezas();
  }
  fecharBuscaNatureza(): void { this.naturezaModalAberta = false; }
  selecionarNatureza(n: { codNat: string | number; descricao: string }): void {
    this.naturezaSelecionada = n.codNat;
    this.naturezaModalAberta = false;
  }
  limparNatureza(): void { this.naturezaSelecionada = '0'; }

  onInputTipoNegociacao(event: Event): void {
    const input = event.target as HTMLInputElement;
    const val   = input.value;
    const cur   = input.selectionStart ?? val.length;
    const idx   = val.indexOf(' - ');
    const cod   = idx >= 0 ? val.substring(0, idx) : val;
    this.tipoNegociacaoSelecionado = cod;
    const novo = this.valorExibidoTipoNegociacao(cod);
    setTimeout(() => {
      input.value = novo;
      const pos = Math.min(cur, cod.length);
      input.setSelectionRange(pos, pos);
    });
  }

  // ── Centro de Resultado (CODCENCUS) ─────────────────────────
  centrosResultado: { codCen: string | number; descricao: string }[] = [
    { codCen: '0', descricao: 'Nenhum' },
  ];
  // Default 201000 - COMPRAS (pedido do usuário).
  centroResultadoSelecionado: string | number = '201000';
  centroResultadoModalAberta  = false;
  filtroCentroResultado       = '';
  centrosResultadoCarregando  = false;

  get centrosResultadoFiltrados() {
    const f = this.filtroCentroResultado.trim().toUpperCase();
    return f
      ? this.centrosResultado.filter(c => (c.descricao || '').toUpperCase().includes(f) || String(c.codCen).includes(f))
      : this.centrosResultado;
  }

  descricaoCentroResultado(cod: string | number): string {
    return this.centrosResultado.find(c => String(c.codCen) === String(cod))?.descricao ?? '';
  }

  valorExibidoCentroResultado(cod: string | number): string {
    const desc = this.descricaoCentroResultado(cod);
    return desc ? `${cod} - ${desc}` : String(cod ?? '');
  }

  onInputCentroResultado(event: Event): void {
    const input = event.target as HTMLInputElement;
    const val   = input.value;
    const cur   = input.selectionStart ?? val.length;
    const idx   = val.indexOf(' - ');
    const cod   = idx >= 0 ? val.substring(0, idx) : val;
    this.centroResultadoSelecionado = cod;
    const novo = this.valorExibidoCentroResultado(cod);
    setTimeout(() => {
      input.value = novo;
      const pos = Math.min(cur, cod.length);
      input.setSelectionRange(pos, pos);
    });
  }

  abrirBuscaCentroResultado(): void {
    this.filtroCentroResultado = '';
    this.centroResultadoModalAberta = true;
    this._carregarCentrosResultado();
  }
  fecharBuscaCentroResultado(): void { this.centroResultadoModalAberta = false; }
  selecionarCentroResultado(c: { codCen: string | number; descricao: string }): void {
    this.centroResultadoSelecionado = c.codCen;
    this.centroResultadoModalAberta = false;
  }
  limparCentroResultado(): void { this.centroResultadoSelecionado = '0'; }

  // ── Projeto (CODPROJ) ─────────────────────────────────────
  projetos: { codProj: string | number; descricao: string }[] = [
    { codProj: '0', descricao: 'Nenhum' },
  ];
  // Default 1000000000 - GLOBAL PARTS IMPORTAÇÕES, fixo (confirmado com o
  // usuário -- não varia por Nacional/Importação, já que isso só é
  // descoberto depois, por item, e um mesmo pedido pode ter os dois).
  projetoSelecionado: string | number = '1000000000';
  projetoModalAberta  = false;
  filtroProjeto       = '';
  projetosCarregando  = false;

  get projetosFiltrados() {
    const f = this.filtroProjeto.trim().toUpperCase();
    return f
      ? this.projetos.filter(p => (p.descricao || '').toUpperCase().includes(f) || String(p.codProj).includes(f))
      : this.projetos;
  }

  descricaoProjeto(cod: string | number): string {
    return this.projetos.find(p => String(p.codProj) === String(cod))?.descricao ?? '';
  }

  valorExibidoProjeto(cod: string | number): string {
    const desc = this.descricaoProjeto(cod);
    return desc ? `${cod} - ${desc}` : String(cod ?? '');
  }

  onInputProjeto(event: Event): void {
    const input = event.target as HTMLInputElement;
    const val   = input.value;
    const cur   = input.selectionStart ?? val.length;
    const idx   = val.indexOf(' - ');
    const cod   = idx >= 0 ? val.substring(0, idx) : val;
    this.projetoSelecionado = cod;
    const novo = this.valorExibidoProjeto(cod);
    setTimeout(() => {
      input.value = novo;
      const pos = Math.min(cur, cod.length);
      input.setSelectionRange(pos, pos);
    });
  }

  abrirBuscaProjeto(): void {
    this.filtroProjeto = '';
    this.projetoModalAberta = true;
    this._carregarProjetos();
  }
  fecharBuscaProjeto(): void { this.projetoModalAberta = false; }
  selecionarProjeto(p: { codProj: string | number; descricao: string }): void {
    this.projetoSelecionado = p.codProj;
    this.projetoModalAberta = false;
  }
  limparProjeto(): void { this.projetoSelecionado = '0'; }

  // ── Cotação (VLRMOEDA) ──────────────────────────────────────
  cotacoesDisponiveis: DemonstrativoCotacao[] = [];
  cotacaoModalAberta  = false;
  cotacaoCarregando   = false;
  cotacaoTexto        = '';
  cotacaoSelecionada: DemonstrativoCotacao | null = null;
  filtroCotacao       = '';

  get cotacaoValorNumerico(): number {
    const raw = this.cotacaoSelecionada?.valor ?? this.cotacaoTexto?.split('|')[0].trim();
    return parseFloat(String(raw ?? '').replace(',', '.')) || 0;
  }

  get cotacoesFiltradas(): DemonstrativoCotacao[] {
    const t = this.filtroCotacao.trim().toLowerCase();
    return t
      ? this.cotacoesDisponiveis.filter(c =>
          String(c.valor ?? '').toLowerCase().includes(t) ||
          this._dataCotacao(c).toLowerCase().includes(t))
      : this.cotacoesDisponiveis;
  }

  private _dataCotacao(c: DemonstrativoCotacao): string {
    return String(c.data ?? c.DATA_BR ?? c.DATA ?? c.DTMOV ?? '');
  }

  private _fmtCotacao(c: DemonstrativoCotacao): string {
    const data = this._dataCotacao(c);
    return `${c.valor}${data ? '  |  ' + data : ''}`;
  }

  async abrirBuscaCotacao(): Promise<void> {
    this.filtroCotacao = '';
    this.cotacaoModalAberta = true;
    await this._carregarCotacoes();
  }

  fecharBuscaCotacao(): void { this.cotacaoModalAberta = false; }

  selecionarCotacao(c: DemonstrativoCotacao): void {
    this.cotacaoSelecionada = c;
    this.cotacaoTexto = this._fmtCotacao(c);
    this.cotacaoModalAberta = false;
    this._recalcularPrecos();
  }

  limparCotacao(): void {
    this.cotacaoSelecionada = null;
    this.cotacaoTexto = '';
    this._recalcularPrecos();
  }

  private _recalcularPrecos(): void {
    const taxa = this.cotacaoValorNumerico;
    for (const item of this.itens) {
      if (item.fabricanteNacional) {
        // Nacional: R$ é o mestre -- ao trocar a cotação, recalcula o U$.
        if (item.precoUnitario > 0 && taxa > 0) {
          item.precoUsd    = parseFloat((item.precoUnitario / taxa).toFixed(2));
          item.precoUsdStr = this.fmtMoeda(item.precoUsd);
          this._calcularTotal(item);
        }
      } else if (item.precoUsd > 0 && taxa > 0) {
        item.precoUnitario = parseFloat((item.precoUsd * taxa).toFixed(2));
        this._calcularTotal(item);
      }
    }
  }

  // ── Fabricante nacional (parâmetro FABNAC, mesmo da Venda) ─────────────
  private _fabnac: number[] = [70];
  private _fabnacPromise: Promise<void> | null = null;

  private _carregarFabnac(): Promise<void> {
    if (!this._fabnacPromise) {
      this._fabnacPromise = (async () => {
        try {
          const res: any = await firstValueFrom(this.gateway.buscarValoresParametros(['FABNAC']));
          const body = res?.responseBody ?? res;
          const bruto = String(body?.valores?.['FABNAC'] ?? '').trim();
          const lista = bruto.split(',').map(s => parseInt(s.trim(), 10)).filter(n => Number.isFinite(n));
          this._fabnac = lista.length > 0 ? lista : [70];
        } catch { /* mantém [70] */ }
      })();
    }
    return this._fabnacPromise;
  }

  /** Marca item.fabricanteNacional pelo CODMARCA do produto. */
  private async _resolverNacional(item: ItemCompra): Promise<void> {
    if (!item.codprodInterno) return;
    await this._carregarFabnac();
    try {
      const res: any = await firstValueFrom(this.produtoService.buscarProdutoCompleto(item.codprodInterno));
      const codMarca = Number(res?.dados?.['CODMARCA']);
      item.fabricanteNacional = this._fabnac.includes(codMarca);
      if (item.fabricanteNacional && item.precoUnitario > 0) {
        item.precoBrlStr = this.fmtDecimal(item.precoUnitario);
      }
    } catch { /* ignora */ }
  }

  /** Nacional: digitou o Custo R$ -> U$ = R$ ÷ cotação do dia. */
  onPrecoBrlBlur(item: ItemCompra): void {
    const val = parseFloat((item.precoBrlStr ?? '').replace(',', '.'));
    if (!isNaN(val) && val >= 0) {
      item.precoUnitario = val;
      const taxa = this.cotacaoValorNumerico;
      if (taxa > 0) {
        item.precoUsd    = parseFloat((val / taxa).toFixed(2));
        item.precoUsdStr = item.precoUsd > 0 ? this.fmtMoeda(item.precoUsd) : '';
      }
      this._calcularTotal(item);
    }
    item.precoBrlStr = item.precoUnitario > 0 ? this.fmtDecimal(item.precoUnitario) : '';
  }

  // ── Itens ───────────────────────────────────────────────────
  private _proximoId = 2;

  itens: ItemCompra[] = [this._novoItem()];

  private _novoItem(): ItemCompra {
    return {
      id: this._proximoId++,
      codprod: '', descricao: '', unidade: 'UN',
      quantidade: 1, precoUsd: 0, precoUnitario: 0,
      desconto: 0, vlrDesc: 0, vlrAcrescDesc: 0,
      total: 0, totalUsd: 0, estoque: 0,
      statusItem: 'ABERTO',
    };
  }

  adicionarLinha(): void {
    this.itens.push(this._novoItem());
  }

  /** Item aguardando confirmação de exclusão (null = modal fechado). */
  itemParaExcluir: ItemCompra | null = null;

  /** Clique na lixeira: pede confirmação antes de excluir (linha vazia sai direto). */
  removerItem(id: number): void {
    const item = this.itens.find(i => i.id === id);
    if (!item) { return; }
    if (!(item.codprod || item.descricao || item.codprodInterno)) {
      this.itens = this.itens.filter(i => i.id !== id);
      if (this.itens.length === 0) this.itens.push(this._novoItem());
      return;
    }
    this.itemParaExcluir = item;
  }

  confirmarExclusaoItem(): void {
    const item = this.itemParaExcluir;
    this.itemParaExcluir = null;
    if (!item) { return; }
    this.itens = this.itens.filter(i => i.id !== item.id);
    if (this.itens.length === 0) this.itens.push(this._novoItem());   // último/único item: recria a linha vazia
  }

  cancelarExclusaoItem(): void {
    this.itemParaExcluir = null;
  }

  get totalGeral(): number {
    return this.itens.reduce((s, i) => s + (i.total || 0), 0);
  }

  get totalGeralUsd(): number {
    return this.itens.reduce((s, i) => s + (i.totalUsd || 0), 0);
  }

  /**
   * Soma da coluna CUSTO TOTAL (custo unitário × quantidade) das linhas com
   * produto carregado -- o CUSTO que vem do Aerosys (EST_CUSTO) é em U$,
   * mesma unidade usada em "Total Pedido U$" -- por isso NÃO usa fmtMoeda
   * (que é R$) sozinho; ver totalCustoTotalAnaliticoBrl abaixo pra a
   * conversão usando a cotação do dia.
   */
  get totalCustoTotalAnaliticoUsd(): number {
    return this.itensValidos.reduce((s, i) => s + ((i.custoAnalitico ?? 0) * (i.quantidade || 0)), 0);
  }

  /** Custo Total convertido pra R$ pela cotação do dólar selecionada no
   *  pedido (cotacaoValorNumerico) -- mesma cotação usada pra calcular
   *  Preço R$ dos itens a partir do Preço U$. */
  get totalCustoTotalAnaliticoBrl(): number {
    return this.totalCustoTotalAnaliticoUsd * this.cotacaoValorNumerico;
  }

  get itensValidos(): ItemCompra[] {
    return this.itens.filter(i => i.codprodInterno && i.codprodInterno > 0);
  }

  _calcularTotal(item: ItemCompra): void {
    const base = item.quantidade * item.precoUnitario;
    item.total    = parseFloat((base - (item.vlrDesc || 0) + (item.vlrAcrescDesc || 0)).toFixed(2));
    const baseUsd = item.quantidade * item.precoUsd;
    item.totalUsd = item.precoUsd > 0
      ? parseFloat((baseUsd - baseUsd * ((item.desconto || 0) / 100)).toFixed(2))
      : 0;
  }

  onQtdChange(item: ItemCompra): void { this._calcularTotal(item); }

  onPrecoUsdBlur(item: ItemCompra, event: Event): void {
    const raw = (item.precoUsdStr ?? '').replace(',', '.');
    const val = Math.round(parseFloat(raw) * 100) / 100;
    if (!isNaN(val)) {
      item.precoUsd = val;
      const taxa = this.cotacaoValorNumerico;
      if (taxa > 0) { item.precoUnitario = parseFloat((val * taxa).toFixed(2)); }
      item.precoUsdStr = this.fmtMoeda(val);
      this._calcularTotal(item);
    }
    (event.target as HTMLInputElement).value = item.precoUsdStr ?? '';
  }

  onDescontoChange(item: ItemCompra): void {
    const base = item.quantidade * item.precoUnitario;
    if (base > 0) {
      item.vlrDesc = parseFloat((base * (item.desconto || 0) / 100).toFixed(2));
    }
    this._calcularTotal(item);
  }

  // ── Painel "Peças com Venda nos últimos X meses" (Aerosys + Sankhya) ──
  qtdeVendidaDtDe       = this._dataAnaliticoPadrao(-3);
  qtdeVendidaDtAte      = this._dataAnaliticoPadrao(0);
  qtdeVendidaCarregando = false;
  qtdeVendidaCarregada  = false;
  /** Dispara buscarQtdeVendida() sozinho (sem botão) sempre que item/data mudam, com debounce. */
  private _qtdeVendidaSubject = new Subject<void>();

  /** Ponte entre o texto "dd/MM/yyyy HH:mm" (usado na API) e o <input type="datetime-local"> ("yyyy-MM-ddTHH:mm"). */
  private _brParaIso(br: string, fimDoDia: boolean): string {
    const m = /^(\d{2})\/(\d{2})\/(\d{4})(?:\s+(\d{2}):(\d{2}))?$/.exec((br || '').trim());
    if (!m) return '';
    const hora = m[4] ? `${m[4]}:${m[5]}` : (fimDoDia ? '23:59' : '00:00');
    return `${m[3]}-${m[2]}-${m[1]}T${hora}`;
  }
  private _isoParaBr(iso: string): string {
    const m = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/.exec(iso || '');
    return m ? `${m[3]}/${m[2]}/${m[1]} ${m[4]}:${m[5]}` : '';
  }
  /** Ao clicar no campo de data, abre o calendário na hora (o teclado continua valendo via Tab/setas). */
  abrirSeletorData(ev: Event): void {
    const el = ev.target as HTMLInputElement;
    try { el.showPicker?.(); } catch { /* navegador sem suporte: segue o comportamento padrão */ }
  }
  get qtdeVendidaDeIso(): string { return this._brParaIso(this.qtdeVendidaDtDe, false); }
  set qtdeVendidaDeIso(v: string) { const br = this._isoParaBr(v); if (br) this.qtdeVendidaDtDe = br; }
  get qtdeVendidaAteIso(): string { return this._brParaIso(this.qtdeVendidaDtAte, true); }
  set qtdeVendidaAteIso(v: string) { const br = this._isoParaBr(v); if (br) this.qtdeVendidaDtAte = br; }

  private _dataAnaliticoPadrao(deslocMeses: number): string {
    const d = new Date();
    d.setMonth(d.getMonth() + deslocMeses);
    const dd   = String(d.getDate()).padStart(2, '0');
    const mm   = String(d.getMonth() + 1).padStart(2, '0');
    const yyyy = d.getFullYear();
    const hh   = String(d.getHours()).padStart(2, '0');
    const mi   = String(d.getMinutes()).padStart(2, '0');
    // Com hora (igual ao relatório nativo do Aerosys, que grava o período com a hora de criação)
    return `${dd}/${mm}/${yyyy} ${hh}:${mi}`;
  }

  /** NACIONAL=1 / IMPORTAÇÃO=12 -- mesmas constantes do dual-write no backend (PedidoCompraComponent) */
  private get _empresaAerosysDoTipo(): number {
    return this.tipoGpl === 'NACIONAL' ? 1 : 12;
  }

  /** Chamar sempre que item ou data do filtro mudarem -- dispara buscarQtdeVendida() sozinho, com debounce. */
  onFiltroQtdeVendidaMudou(): void {
    this._qtdeVendidaSubject.next();
  }

  async buscarQtdeVendida(): Promise<void> {
    const codProds = Array.from(new Set(
      this.itens
        .map(i => i.codprodInterno)
        .filter((c): c is number => !!c && c > 0)
    ));
    if (codProds.length === 0) return;

    const codEmpSankhya = parseInt(this.empresaState.codEmpReal ?? '0', 10) || 0;
    if (!codEmpSankhya) return;

    this.qtdeVendidaCarregando = true;
    try {
      // Em lotes -- o Oracle rejeita CODPROD IN (...) com mais de 1000
      // itens (ORA-01795), e o lado Aerosys tem várias subqueries
      // correlacionadas por item na mesma consulta, então uma lista muito
      // grande de uma vez só também fica pesada/lenta demais e tende a dar
      // timeout. Antes da importação em massa (Funções > Peças com Venda)
      // um pedido nunca passava de umas dezenas de itens, então esse limite
      // nunca tinha sido alcançado -- com 1000+ itens de uma vez ele batia
      // direto no ORA-01795 e a chamada inteira falhava silenciosamente
      // (erro só ia pro console, ver comentário abaixo), deixando todas as
      // colunas desse painel em branco pros itens importados.
      const TAMANHO_LOTE = 300;
      const CONCORRENCIA = 3;
      const lotes: number[][] = [];
      for (let i = 0; i < codProds.length; i += TAMANHO_LOTE) {
        lotes.push(codProds.slice(i, i + TAMANHO_LOTE));
      }
      for (let i = 0; i < lotes.length; i += CONCORRENCIA) {
        const grupo = lotes.slice(i, i + CONCORRENCIA);
        await Promise.all(grupo.map(lote => this._aplicarQtdeVendidaLote(lote, codEmpSankhya)));
      }
      this.qtdeVendidaCarregada = true;
    } catch {
      // Painel de apoio à decisão -- falha não pode travar a tela do pedido
    } finally {
      this.qtdeVendidaCarregando = false;
    }
  }

  /** Busca e aplica o painel "Peças com Venda" pra 1 lote de CODPROD (ver
   *  motivo do lote em buscarQtdeVendida() acima). Falha isolada de um lote
   *  não derruba os demais -- cada lote atualiza os itens dele independente. */
  private async _aplicarQtdeVendidaLote(codProds: number[], codEmpSankhya: number): Promise<void> {
    try {
      const res: any = await firstValueFrom(
        this.gateway.buscarAnaliticoItensPedidoCompra(
          codProds, codEmpSankhya, this._empresaAerosysDoTipo,
          this.qtdeVendidaDtDe, this.qtdeVendidaDtAte
        ).pipe(timeout(30000))
      );
      // Backend devolve { itens, erroAerosys, erroSankhya } -- os erros (se
      // houver) são só pra diagnóstico (aba Network/Console), o painel
      // continua mostrando o que der (Aerosys e Sankhya são independentes).
      const linhas: any[] = Array.isArray(res) ? res : (res?.itens ?? []);
      if (res?.erroAerosys) console.warn('[Qtde Vendida] Aerosys:', res.erroAerosys);
      if (res?.erroSankhya) console.warn('[Qtde Vendida] Sankhya:', res.erroSankhya);
      const porCodProd = new Map<number, any>();
      for (const l of linhas) {
        if (l?.codProd != null) porCodProd.set(Number(l.codProd), l);
      }
      for (const item of this.itens) {
        if (!item.codprodInterno) continue;
        const dados = porCodProd.get(item.codprodInterno);
        if (!dados) continue;
        item.cd                = dados.cd ?? undefined;
        // Custo do Aerosys desativado: o custo agora é o Preço do Fabricante (precoUsd).
        // item.custoAnalitico    = dados.custo ?? null;
        item.fabricante        = dados.fabricante ?? '';
        item.pontoPedido       = dados.pontoPedido ?? null;
        item.estoqueEua        = dados.estoqueEua ?? null;
        item.qtdeVendas        = dados.qtdeVendas ?? null;
        item.qtdeVendasAnoAnt  = dados.qtdeVendasAnoAnt ?? null;
        item.qtdePedidoOutros  = dados.qtdePedidoOutros ?? null;
        item.pedidoOutros      = dados.pedidoOutros ?? '';
        item.qtdePrecompraAbBk = dados.qtdePrecompraAbBk ?? null;
        item.dataPrecompraAbBk = dados.dataPrecompraAbBk ?? '';
      }
    } catch {
      // 1 lote falhando não pode travar os demais.
    }
  }

  // ── "Funções" (engrenagem) — menu do cabeçalho de Itens do Pedido ──
  funcoesMenuAberto = false;

  toggleFuncoesMenu(event?: Event): void {
    event?.stopPropagation();
    this.funcoesMenuAberto = !this.funcoesMenuAberto;
  }

  fecharFuncoesMenu(): void {
    this.funcoesMenuAberto = false;
  }

  @HostListener('document:click')
  onDocumentClickFecharFuncoesMenu(): void {
    if (this.funcoesMenuAberto) this.funcoesMenuAberto = false;
    if (this.itemFuncoesAberto) this.itemFuncoesAberto = false;
  }

  // ── "Ações do Item": Cancelar item (somente ABERTOS); Desmembrar fica para depois da Pré-Compra ──
  itemFuncoesAberto = false;
  readonly statusOpcoes: ItemCompra['statusItem'][] = ['ABERTO', 'CANCELADO', 'COMPRADO', 'PARCIAL'];

  toggleItemFuncoes(event?: Event): void {
    event?.stopPropagation();
    this.itemFuncoesAberto = !this.itemFuncoesAberto;
    if (this.itemFuncoesAberto) this.funcoesMenuAberto = false;
  }

  get itensMarcados(): ItemCompra[] {
    return this.itens.filter(i => i.sel && i.codprodInterno);
  }

  /** Cancelar item: só itens ABERTOS (nunca comprados). Os demais marcados são ignorados. */
  cancelarItensMarcados(): void {
    this.itemFuncoesAberto = false;
    const marcados = this.itensMarcados;
    if (marcados.length === 0) {
      this.abrirAlerta('Marque ao menos um item para cancelar.', 'aviso');
      return;
    }
    const abertos = marcados.filter(i => (i.statusItem || 'ABERTO') === 'ABERTO');
    const ignorados = marcados.length - abertos.length;
    if (abertos.length === 0) {
      this.abrirAlerta('Só é possível cancelar itens em ABERTO. Os itens marcados já foram comprados ou cancelados.', 'aviso');
      return;
    }
    abertos.forEach(i => { i.statusItem = 'CANCELADO'; });
    marcados.forEach(i => { i.sel = false; });
    const extra = ignorados > 0 ? ` ${ignorados} item(ns) não estava(m) em ABERTO e foi(ram) ignorado(s).` : '';
    this.abrirAlerta(`${abertos.length} item(ns) cancelado(s).${extra} Salve o pedido para gravar.`, 'sucesso');
  }

  // ── "Funções > Imp. Peças com Venda nos últimos X meses" (checklist) ───
  // Lista de DESCOBERTA (Aerosys + Sankhya reconciliados), respeitando o
  // mesmo período já selecionado no filtro qtdeVendidaDtDe/DtAte -- exclui
  // venda em aberto e orçamento dos dois lados (ver comentários no backend:
  // PedidoCompraAnaliticoComponent#buscarDescoberta). Confirmar adiciona os
  // itens marcados como novas linhas no grid, Quantidade = 1, mesmo padrão
  // da Importação de Excel (confirmarImportacaoExcel).
  descobertaAberta      = false;
  descobertaCarregando  = false;
  descobertaImportando  = false;
  descobertaProgressoFeito  = 0;
  descobertaProgressoTotal  = 0;
  descobertaErro: string | null = null;
  descobertaItens: { codProd: number; pn: string; descricao: string; qtdeVendas: number; marcado: boolean; unidade?: string; codLocalPadrao?: number; cd?: string; fabricante?: string }[] = [];
  /** De onde os itens desse checklist vieram -- controla o título/badge do
   *  cabeçalho do modal, já que o mesmo checklist é reaproveitado tanto por
   *  "Imp. Peças com Venda nos últimos X meses" (período) quanto por
   *  "Imp. Peças de uma seleção de Vendas" (vendas escolhidas na busca). */
  descobertaOrigem: 'periodo' | 'vendas' | 'fabricante' = 'periodo';
  descobertaOrigemDetalhe = '';

  get descobertaMarcadosCount(): number {
    return this.descobertaItens.filter(i => i.marcado).length;
  }

  get descobertaTodosMarcados(): boolean {
    return this.descobertaItens.length > 0 && this.descobertaItens.every(i => i.marcado);
  }

  async abrirDescobertaPecasComVenda(): Promise<void> {
    this.fecharFuncoesMenu();
    const codEmpSankhya = parseInt(this.empresaState.codEmpReal ?? '0', 10) || 0;
    if (!codEmpSankhya) {
      this.abrirAlerta('Selecione a empresa do pedido antes de importar peças com venda.', 'aviso');
      return;
    }
    this.descobertaOrigem     = 'periodo';
    this.descobertaAberta     = true;
    this.descobertaCarregando = true;
    this.descobertaErro       = null;
    this.descobertaItens      = [];
    try {
      const res: any = await firstValueFrom(
        this.gateway.buscarDescobertaPecasComVenda(
          codEmpSankhya, this._empresaAerosysDoTipo,
          this.qtdeVendidaDtDe, this.qtdeVendidaDtAte
        )
      );
      const linhas: any[] = Array.isArray(res) ? res : (res?.itens ?? []);
      this.descobertaItens = linhas
        .filter(l => l?.pn)
        .map(l => ({
          codProd:        Number(l.codProd) || 0,
          pn:             String(l.pn),
          descricao:      l.descricao ?? '',
          qtdeVendas:     Number(l.qtdeVendas) || 0,
          marcado:        true,
          unidade:        l.unidade || undefined,
          codLocalPadrao: Number(l.codLocalPadrao) || undefined,
          cd:             l.cd || undefined,
        }));
      if (this.descobertaItens.length === 0) {
        this.descobertaErro = 'Nenhuma peça com venda fechada nesse período.';
      }
      void this._carregarFabricantesDescoberta();
    } catch {
      this.descobertaErro = 'Não foi possível buscar as peças com venda no período. Tente novamente.';
    } finally {
      this.descobertaCarregando = false;
    }
  }

  /** Preenche a coluna Fabricante da lista de importação (busca em lotes, sem travar a abertura da tela). */
  private async _carregarFabricantesDescoberta(): Promise<void> {
    const itens = this.descobertaItens;
    const codProds = Array.from(new Set(itens.map(i => i.codProd).filter(c => c > 0)));
    for (let i = 0; i < codProds.length; i += 500) {
      try {
        const res: any = await firstValueFrom(this.gateway.buscarFabricantesPorCodProd(codProds.slice(i, i + 500)));
        const mapa = res?.fabricantes ?? {};
        for (const item of itens) {
          const nome = mapa[String(item.codProd)];
          if (nome !== undefined) item.fabricante = nome;
        }
      } catch { /* coluna de apoio: falha não impede a importação */ }
      if (this.descobertaItens !== itens) return;   // lista foi trocada/fechada enquanto carregava
    }
  }

  toggleDescobertaTodos(): void {
    const marcarTodos = !this.descobertaTodosMarcados;
    this.descobertaItens.forEach(i => i.marcado = marcarTodos);
  }

  fecharDescoberta(): void {
    this.descobertaAberta = false;
    this.descobertaItens  = [];
    this.descobertaErro   = null;
  }

  // ── "Funções > Imp. Peças de uma seleção de Vendas" (Geral / Apenas
  // Importação) ────────────────────────────────────────────────────────
  // Busca vendas (Aerosys + Sankhya) por cliente/NUNOTA/N° título, permite
  // marcar várias, e reaproveita o MESMO checklist (descobertaItens/
  // descobertaAberta/confirmarDescoberta) já usado por "Imp. Peças com
  // Venda" acima pra revisar e importar os itens combinados.
  buscaVendasAberta           = false;
  buscaVendasApenasImportacao = false;
  buscaVendasTermo            = '';
  buscaVendasCarregando       = false;
  buscaVendasErro: string | null = null;
  /** true = falha real (conexão/erro dos sistemas); false = só "nenhuma venda encontrada". */
  buscaVendasAvisoErro = false;
  buscaVendasResultados: {
    sistema: 'sankhya' | 'aerosys'; id: number; numero: string;
    cliente: string; prefixo?: string; data: string; dataOrdenavel: number; valor: number; tipo: string; status?: string; marcado: boolean;
  }[] = [];
  /** Clique no cabeçalho da coluna reordena (mesmo padrão de
   *  ordenarBuscaPecas() no modal F3, sem os filtros inline por coluna --
   *  aqui é só reordenação). */
  buscaVendasOrdenarCampo: string | null = null;
  buscaVendasOrdemAsc = true;

  get buscaVendasMarcadosCount(): number {
    return this.buscaVendasResultados.filter(v => v.marcado).length;
  }

  ordenarBuscaVendas(campo: string): void {
    if (this.buscaVendasOrdenarCampo === campo) {
      this.buscaVendasOrdemAsc = !this.buscaVendasOrdemAsc;
    } else {
      this.buscaVendasOrdenarCampo = campo;
      this.buscaVendasOrdemAsc = true;
    }
    const dir = this.buscaVendasOrdemAsc ? 1 : -1;
    // "data" usa o campo numérico auxiliar (dataOrdenavel) pra ordenar
    // cronologicamente -- comparar a string formatada "DD/MM/YYYY HH:mm"
    // como texto ordenaria pelo dia primeiro, não pela data real.
    const campoReal = campo === 'data' ? 'dataOrdenavel' : campo;
    this.buscaVendasResultados = [...this.buscaVendasResultados].sort((a, b) => {
      const va = (a as any)[campoReal];
      const vb = (b as any)[campoReal];
      if (va == null && vb == null) return 0;
      if (va == null) return 1;
      if (vb == null) return -1;
      if (typeof va === 'string' && typeof vb === 'string') return va.localeCompare(vb, 'pt-BR') * dir;
      return ((va as number) - (vb as number)) * dir;
    });
  }

  abrirBuscaVendas(apenasImportacao: boolean): void {
    this.fecharFuncoesMenu();
    this.buscaVendasApenasImportacao = apenasImportacao;
    this.buscaVendasTermo            = '';
    this.buscaVendasResultados       = [];
    this.buscaVendasErro             = null;
    this.buscaVendasAberta           = true;
    this.buscarVendas(); // ja abre com as vendas mais recentes
    setTimeout(() => document.getElementById('pcf-busca-vendas-input')?.focus(), 60);
  }

  fecharBuscaVendas(): void {
    this.buscaVendasAberta     = false;
    this.buscaVendasResultados = [];
    this.buscaVendasErro       = null;
  }

  /** Sankhya já vem formatado "DD/MM/YYYY HH:mm" (TO_CHAR no backend) --
   *  passa direto. Aerosys vem cru do banco (ISO, ex.:
   *  "2026-08-11T17:53:41.274Z"), sem formatação nenhuma -- formata aqui
   *  pro mesmo padrão, senão a coluna Data fica com dois formatos
   *  diferentes lado a lado na mesma tabela. */
  private _formatarDataBuscaVendas(data: string): string {
    if (!data) return '';
    if (data.includes('/')) return data;
    const d = new Date(data);
    if (isNaN(d.getTime())) return data;
    const pad = (n: number) => String(n).padStart(2, '0');
    return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
  }

  /** Valor numérico (epoch ms) da mesma data acima, só pra ordenar a coluna
   *  Data cronologicamente -- comparar "DD/MM/YYYY HH:mm" como texto
   *  ordenaria pelo dia primeiro, não pela data real. */
  private _dataOrdenavelBuscaVendas(data: string): number {
    if (!data) return 0;
    if (data.includes('/')) {
      const m = data.match(/^(\d{2})\/(\d{2})\/(\d{4})(?:\s+(\d{2}):(\d{2}))?/);
      if (!m) return 0;
      const [, dd, mm, yyyy, hh, min] = m;
      return new Date(Number(yyyy), Number(mm) - 1, Number(dd), Number(hh || 0), Number(min || 0)).getTime();
    }
    const t = new Date(data).getTime();
    return isNaN(t) ? 0 : t;
  }

  async buscarVendas(): Promise<void> {
    const termo = this.buscaVendasTermo.trim();
    // termo vazio = lista as vendas mais recentes (Aerosys + Sankhya)
    const codEmpSankhya = parseInt(this.empresaState.codEmpReal ?? '0', 10) || 0;
    if (!codEmpSankhya) {
      this.abrirAlerta('Selecione a empresa do pedido antes de buscar vendas.', 'aviso');
      return;
    }

    this.buscaVendasCarregando = true;
    this.buscaVendasErro       = null;
    try {
      const res: any = await firstValueFrom(
        this.gateway.buscarVendasPorTermo(
          codEmpSankhya, this._empresaAerosysDoTipo, termo, this.buscaVendasApenasImportacao
        ).pipe(timeout(20000))
      );
      // Antes esses erros só iam pro console (invisível pro usuário) -- se
      // um dos dois sistemas falhar (ex.: Sankhya) enquanto o outro
      // funciona, a tela parecia "só carrega Aerosys" sem explicação
      // nenhuma. Agora aparece como aviso mesmo quando o outro lado trouxe
      // resultado.
      const avisos: string[] = [];
      if (res?.erroAerosys) { console.warn('[Busca Vendas] Aerosys:', res.erroAerosys); avisos.push('Aerosys: ' + res.erroAerosys); }
      if (res?.erroSankhya) { console.warn('[Busca Vendas] Sankhya:', res.erroSankhya); avisos.push('Sankhya: ' + res.erroSankhya); }
      const linhas: any[] = res?.vendas ?? [];
      this.buscaVendasResultados = linhas.map((v: any) => ({
        sistema:       v.sistema,
        id:            Number(v.id) || 0,
        numero:        String(v.numero ?? ''),
        cliente:       v.cliente ?? '',
        prefixo:       v.prefixo ?? '',
        data:          this._formatarDataBuscaVendas(v.data),
        dataOrdenavel: this._dataOrdenavelBuscaVendas(v.data),
        valor:         Number(v.valor) || 0,
        tipo:          v.tipo ?? '',
        status:        v.status ?? '',
        marcado:       false,
      }));
      // Aerosys primeiro; dentro de cada sistema, a mais recente primeiro.
      this.buscaVendasResultados.sort((a, b) =>
        (Number(a.sistema === 'aerosys' ? 0 : 1) - Number(b.sistema === 'aerosys' ? 0 : 1)) || (b.dataOrdenavel - a.dataOrdenavel));
      // Sem pesquisa: só as 5 vendas mais recentes (dos dois sistemas). Pesquisando: tudo que bater.
      if (!termo) {
        this.buscaVendasResultados = [...this.buscaVendasResultados]
          .sort((a, b) => b.dataOrdenavel - a.dataOrdenavel)
          .slice(0, 5);
      }
      this.buscaVendasAvisoErro = avisos.length > 0;
      if (this.buscaVendasResultados.length === 0) {
        if (avisos.length > 0) {
          this.buscaVendasErro = avisos.join(' | ');
        } else {
          // Sem erro nenhum: a busca rodou nos dois sistemas e nada bateu.
          const filtro = this.buscaVendasApenasImportacao ? ' Filtro ativo: apenas vendas de Importação.' : '';
          const diag = res?.diagnosticoSankhya ? ' ' + res.diagnosticoSankhya : '';
          this.buscaVendasErro = termo
            ? `Nenhuma venda encontrada para "${termo}" no Sankhya nem no Aerosys.${filtro}${diag}`
            : `Nenhuma venda encontrada no Sankhya nem no Aerosys.${filtro}`;
        }
      } else {
        this.buscaVendasErro = avisos.length > 0 ? avisos.join(' | ') : null;
      }
    } catch {
      this.buscaVendasAvisoErro = true;
      this.buscaVendasErro = 'Não foi possível buscar as vendas. Tente novamente.';
    } finally {
      this.buscaVendasCarregando = false;
    }
  }

  /** Busca os itens combinados das vendas marcadas e abre o checklist de
   *  importação (descobertaAberta) já reaproveitado de "Imp. Peças com
   *  Venda" -- confirmarDescoberta() dali importa os itens marcados. */
  /** Texto das vendas escolhidas em "Imp. Peças de uma seleção de Vendas" (ex.: "Aerosys 123, Sankhya 2536"). */
  descobertaVendasRef = '';
  /** Vendedor (CODVEND) da venda escolhida -- vira o Comprador do pedido ao importar. */
  descobertaVendedorCodVend: number | null = null;

  async confirmarSelecaoVendas(): Promise<void> {
    const marcadas = this.buscaVendasResultados.filter(v => v.marcado);
    if (marcadas.length === 0) return;

    this.buscaVendasCarregando = true;
    try {
      const res: any = await firstValueFrom(
        this.gateway.buscarItensDeVendasSelecionadas(
          this._empresaAerosysDoTipo,
          marcadas.map(v => ({ sistema: v.sistema, id: v.id }))
        ).pipe(timeout(30000))
      );
      const linhas: any[] = res?.itens ?? [];
      const erros: string[] = res?.erros ?? [];
      this.descobertaItens = linhas
        .filter((l: any) => l?.pn)
        .map((l: any) => ({
          codProd:        Number(l.codProd) || 0,
          pn:             String(l.pn),
          descricao:      l.descricao ?? '',
          qtdeVendas:     Number(l.qtde) || 0,
          marcado:        true,
          unidade:        l.unidade || undefined,
          codLocalPadrao: Number(l.codLocalPadrao) || undefined,
          cd:             l.cd || undefined,
        }));
      // Registro das vendas escolhidas (vai pra Observacao do Comprador ao importar).
      this.descobertaVendedorCodVend = Number(res?.codVend) > 0 ? Number(res.codVend) : null;
      this.descobertaVendasRef = marcadas
        // Uma linha por venda: "Venda(s): 05056537/26 (PS-CCS) NOME DO CLIENTE" (sem parênteses quando não há prefixo)
        .map(v => `Venda(s): ${v.numero}${v.prefixo ? ` (${v.prefixo})` : ''}${v.cliente ? ` ${v.cliente}` : ''}`)
        .join('\n');
      this.fecharBuscaVendas();
      this.descobertaOrigem        = 'vendas';
      this.descobertaOrigemDetalhe = marcadas.length + (marcadas.length === 1 ? ' venda selecionada' : ' vendas selecionadas');
      this.descobertaAberta = true;
      void this._carregarFabricantesDescoberta();
      // Mostra o motivo real (venda sem itens, erro Aerosys/Sankhya, etc.)
      // em vez de um "nenhum item" genérico -- antes isso ficava 100%
      // silencioso e só aparecia "0 itens" sem explicação nenhuma.
      this.descobertaErro = this.descobertaItens.length === 0
        ? (erros.length > 0 ? erros.join(' | ') : 'Nenhum item encontrado nas vendas selecionadas.')
        : null;
    } catch {
      this.buscaVendasErro = 'Não foi possível buscar os itens das vendas selecionadas. Tente novamente.';
    } finally {
      this.buscaVendasCarregando = false;
    }
  }

  // ── "Funções > Imp. Peças de um Fabricante" ─────────────────────────────
  // Por ora só lista os fabricantes combinados (Sankhya TGFMAR + Aerosys
  // FABRICANTE, reconciliados por código no backend -- ver
  // BuscaFabricanteComponent). A seleção/importação de peças por fabricante
  // vem numa etapa seguinte, a pedido do usuário ("pode começar listando os
  // fabricantes inicialmente").
  buscaFabricanteAberta      = false;
  buscaFabricanteCarregando  = false;
  buscaFabricanteErro: string | null = null;
  buscaFabricanteTermo       = '';
  buscaFabricanteLista: { codigo: number; nome: string; sankhya: boolean; aerosys: boolean }[] = [];
  /** Já carregado nessa sessão do form -- evita rebuscar toda vez que o
   *  usuário reabre o modal (lista de fabricantes muda raramente). */
  private _fabricantesJaCarregados = false;

  /** Clique no cabeçalho da coluna reordena (mesmo padrão de
   *  ordenarBuscaVendas() acima). */
  buscaFabricanteOrdenarCampo: string | null = null;
  buscaFabricanteOrdemAsc = true;

  get buscaFabricanteListaFiltrada(): { codigo: number; nome: string; sankhya: boolean; aerosys: boolean }[] {
    const termo = this.buscaFabricanteTermo.trim().toLowerCase();
    // Sem pesquisa: só os 10 primeiros (por código). Pesquisando: tudo que bater com o nome ou o código.
    if (!termo) {
      if (this.buscaFabricanteOrdenarCampo) return this.buscaFabricanteLista.slice(0, 10);
      return [...this.buscaFabricanteLista].sort((a, b) => a.codigo - b.codigo).slice(0, 10);
    }
    return this.buscaFabricanteLista.filter(f =>
      f.nome.toLowerCase().includes(termo) || String(f.codigo).includes(termo)
    );
  }

  ordenarBuscaFabricante(campo: string): void {
    if (this.buscaFabricanteOrdenarCampo === campo) {
      this.buscaFabricanteOrdemAsc = !this.buscaFabricanteOrdemAsc;
    } else {
      this.buscaFabricanteOrdenarCampo = campo;
      this.buscaFabricanteOrdemAsc = true;
    }
    const dir = this.buscaFabricanteOrdemAsc ? 1 : -1;
    this.buscaFabricanteLista = [...this.buscaFabricanteLista].sort((a: any, b: any) => {
      // "sistemas" não é um campo direto -- ordena por Sankhya+Aerosys(2) >
      // só um dos dois(1), pra agrupar "nos dois sistemas" primeiro/último.
      const va = campo === 'sistemas' ? (Number(a.sankhya) + Number(a.aerosys)) : a[campo];
      const vb = campo === 'sistemas' ? (Number(b.sankhya) + Number(b.aerosys)) : b[campo];
      if (va == null && vb == null) return 0;
      if (va == null) return 1;
      if (vb == null) return -1;
      if (typeof va === 'string' && typeof vb === 'string') return va.localeCompare(vb, 'pt-BR') * dir;
      return ((va as number) - (vb as number)) * dir;
    });
  }

  /** 'venda' = só peças do fabricante com venda no período (Venda X meses);
   *  'todas' = todas as peças do fabricante, sem olhar vendas. */
  buscaFabricanteModo: 'venda' | 'todas' = 'venda';

  abrirBuscaFabricante(modo: 'venda' | 'todas' = 'venda'): void {
    this.buscaFabricanteModo = modo;
    this.fecharFuncoesMenu();
    this.buscaFabricanteTermo   = '';
    this.buscaFabricanteAberta  = true;
    if (!this._fabricantesJaCarregados) {
      this._carregarFabricantes();
    }
  }

  fecharBuscaFabricante(): void {
    this.buscaFabricanteAberta = false;
  }

  private async _carregarFabricantes(): Promise<void> {
    this.buscaFabricanteCarregando = true;
    this.buscaFabricanteErro       = null;
    try {
      const res: any = await firstValueFrom(
        this.gateway.listarFabricantes().pipe(timeout(20000))
      );
      const avisos: string[] = [];
      if (res?.erroAerosys) { console.warn('[Busca Fabricante] Aerosys:', res.erroAerosys); avisos.push('Aerosys: ' + res.erroAerosys); }
      if (res?.erroSankhya) { console.warn('[Busca Fabricante] Sankhya:', res.erroSankhya); avisos.push('Sankhya: ' + res.erroSankhya); }
      const linhas: any[] = res?.fabricantes ?? [];
      this.buscaFabricanteLista = linhas.map((f: any) => ({
        codigo:  Number(f.codigo) || 0,
        nome:    f.nome ?? '',
        sankhya: !!f.sankhya,
        aerosys: !!f.aerosys,
      }));
      this._fabricantesJaCarregados = true;
      if (this.buscaFabricanteLista.length === 0) {
        this.buscaFabricanteErro = avisos.length > 0 ? avisos.join(' | ') : 'Nenhum fabricante encontrado.';
      } else {
        this.buscaFabricanteErro = avisos.length > 0 ? avisos.join(' | ') : null;
      }
    } catch {
      this.buscaFabricanteErro = 'Não foi possível carregar os fabricantes. Tente novamente.';
    } finally {
      this.buscaFabricanteCarregando = false;
    }
  }

  /** Clique numa linha do fabricante -- carrega as peças dele (Sankhya
   *  TGFPRO.CODMARCA + Aerosys ADENDO_PECAS.FAB_ID, combinados no backend)
   *  e abre o MESMO checklist (descobertaAberta) já reaproveitado pelas
   *  outras duas origens ("periodo" e "vendas"). */
  buscaFabricanteCarregandoItens = false;

  async selecionarFabricante(f: { codigo: number; nome: string }): Promise<void> {
    if (this.buscaFabricanteCarregandoItens) return;
    this.buscaFabricanteCarregandoItens = true;
    try {
      const codEmpSankhya = parseInt(this.empresaState.codEmpReal ?? '0', 10) || 0;
      // Peças do fabricante + peças com venda no periodo (mesmo periodo/filtro
      // de "Imp. Peças com Venda"): fica so a interseccao, com a Qtde Vendida.
      const todas = this.buscaFabricanteModo === 'todas';
      const [res, vendidas]: [any, any] = await Promise.all([
        firstValueFrom(this.gateway.buscarItensFabricante(f.codigo).pipe(timeout(30000))),
        // Modo "todas": não consulta vendas -- importa tudo do fabricante.
        todas
          ? Promise.resolve(null)
          : firstValueFrom(this.gateway.buscarDescobertaPecasComVenda(
              codEmpSankhya, this._empresaAerosysDoTipo,
              this.qtdeVendidaDtDe, this.qtdeVendidaDtAte
            ).pipe(timeout(30000))),
      ]);
      const linhas: any[] = res?.itens ?? [];
      const erros: string[] = res?.erros ?? [];
      const linhasVenda: any[] = Array.isArray(vendidas) ? vendidas : (vendidas?.itens ?? []);
      const vendasPorCod = new Map<number, number>();
      for (const v of linhasVenda) {
        const cod = Number(v?.codProd) || 0;
        if (cod > 0) vendasPorCod.set(cod, Number(v.qtdeVendas) || 0);
      }
      this.descobertaItens = linhas
        .filter((l: any) => l?.pn && (todas || vendasPorCod.has(Number(l.codProd) || 0)))
        .map((l: any) => ({
          codProd:        Number(l.codProd) || 0,
          pn:             String(l.pn),
          descricao:      l.descricao ?? '',
          qtdeVendas:     vendasPorCod.get(Number(l.codProd) || 0) ?? 0,
          marcado:        true,
          unidade:        l.unidade || undefined,
          codLocalPadrao: Number(l.codLocalPadrao) || undefined,
          cd:             l.cd || undefined,
        }));
      this.fecharBuscaFabricante();
      this.descobertaOrigem        = 'fabricante';
      this.descobertaOrigemDetalhe = f.nome;
      this.descobertaAberta = true;
      void this._carregarFabricantesDescoberta();
      this.descobertaErro = this.descobertaItens.length === 0
        ? (erros.length > 0 ? erros.join(' | ') : (linhas.length > 0 ? 'Nenhuma peça desse fabricante teve venda no período.' : 'Nenhuma peça encontrada para esse fabricante.'))
        : null;
    } catch {
      this.buscaFabricanteErro = 'Não foi possível carregar as peças desse fabricante. Tente novamente.';
    } finally {
      this.buscaFabricanteCarregandoItens = false;
    }
  }

  async confirmarDescoberta(): Promise<void> {
    // Guarda contra clique duplo -- o [disabled] no botão já cobre o caso
    // normal, mas esse "return" aqui garante que nem um clique bem rápido
    // (2 cliques antes do Angular repintar o botão como desabilitado)
    // dispare a importação duas vezes.
    if (this.descobertaImportando) return;

    const marcados = this.descobertaItens.filter(i => i.marcado);
    if (marcados.length === 0) { this.fecharDescoberta(); return; }

    this.descobertaImportando = true;
    try {
      // Remove linha em branco antes de adicionar -- mesmo padrão do Importar Excel.
      this.itens = this.itens.filter(i => !!(i.codprod || i.descricao || i.codprodInterno));

      // Monta as linhas DIRETO com o que já veio da busca de descoberta
      // (codProd/pn/descricao/unidade/codLocalPadrao, tudo em 1 chamada só
      // quando o modal abriu) -- SEM fazer uma busca de produto por PN pra
      // cada item marcado, como fazia antes. Com milhares de itens marcados
      // de uma vez, 1 requisição por item era o gargalo real da lentidão.
      const novos: ItemCompra[] = marcados.map(linha => {
        const novo = this._novoItem();
        novo.codprod         = linha.pn;
        // "Imp. Peças de uma seleção de Vendas": já entra com a quantidade da venda; nas demais origens, 1.
        novo.quantidade      = (this.descobertaOrigem === 'vendas' && Number(linha.qtdeVendas) > 0) ? Number(linha.qtdeVendas) : 1;
        novo.descricao       = linha.descricao ?? '';
        novo.codprodOriginal = linha.pn;
        novo.unidade         = linha.unidade ?? 'UN';
        novo.codprodInterno  = linha.codProd || undefined;
        novo.codlocalpadrao  = linha.codLocalPadrao ?? 0;
        return novo;
      });
      this.itens.push(...novos);

      // Importacao a partir de vendas: o vendedor da venda (Sankhya ou Aerosys) vira o Comprador do pedido.
      if (this.descobertaOrigem === 'vendas' && this.descobertaVendedorCodVend
          && this.compradores.some(v => String(v.codVend) === String(this.descobertaVendedorCodVend))) {
        this.compradorSelecionado = this.descobertaVendedorCodVend;
      }

      // Importacao a partir de vendas: registra o(s) numero(s) da(s) venda(s) na Observacao do Comprador.
      if (this.descobertaOrigem === 'vendas' && this.descobertaVendasRef) {
        const novasLinhas = this.descobertaVendasRef
          .split('\n')
          .filter(l => l && !(this.observacao || '').includes(l));
        if (novasLinhas.length > 0) {
          const registro = novasLinhas.join('\n');
          this.observacao = this.observacao ? `${this.observacao}\n${registro}` : registro;
        }
      }

      // Preço/estoque ainda dependem de 1 chamada por item (não existe
      // endpoint em lote no Sankhya pra isso) -- roda em lotes em paralelo,
      // em vez de 1 por vez (lento) ou todos de uma vez só (sobrecarrega o
      // gateway do Sankhya com milhares de chamadas simultâneas). O
      // descobertaProgressoFeito/Total dá feedback visual no modal --
      // listas grandes demoram mesmo (não tem endpoint em lote no Sankhya),
      // mas assim o usuário vê que está avançando, não travado.
      this.descobertaProgressoFeito = 0;
      this.descobertaProgressoTotal = novos.length;
      await this._executarEmLotes(novos, 10, async item => {
        await this._carregarPrecoEstoqueItem(item);
        this.descobertaProgressoFeito++;
      });

      this.onFiltroQtdeVendidaMudou();
    } finally {
      this.descobertaImportando = false;
      this.descobertaProgressoFeito = 0;
      this.descobertaProgressoTotal = 0;
      this.fecharDescoberta();
    }
  }

  /** Roda `tarefa` pra cada item de `itens`, no máximo `limite` promessas
   *  simultâneas por vez -- meio-termo entre sequencial (lento com listas
   *  grandes) e Promise.all irrestrito (sobrecarrega o servidor quando são
   *  milhares de itens de uma vez). Uma falha isolada não trava o lote --
   *  e cada chamada individual (buscarPrecoExc/buscarEstoquePorLocal) já
   *  tem timeout próprio, então um item que trava não segura o lote inteiro
   *  pra sempre. */
  private async _executarEmLotes<T>(itens: T[], limite: number, tarefa: (item: T) => Promise<void>): Promise<void> {
    for (let i = 0; i < itens.length; i += limite) {
      const lote = itens.slice(i, i + limite);
      await Promise.all(lote.map(item => tarefa(item).catch(() => {})));
    }
  }

  // ── Importação de Excel ─────────────────────────────────────
  excelImportAberto       = false;
  excelImportLinhas: ExcelImportRow[] = [];
  excelImportValidando    = false;
  excelImportando         = false;
  excelImportNomeArquivo  = '';
  excelAproximadosLinha: ExcelImportRow | null = null;
  excelAvisoNaoEncontrado = false;
  excelMapeamentoAberto   = false;
  excelColunas: string[]  = [];
  excelColunaPn: number | null = null;
  excelColunaQty: number | null = null;
  excelRowsRaw: any[][]   = [];
  excelPreviewLinhas: any[][] = [];

  abrirSeletorExcel(): void {
    const input = document.getElementById('pcf-excel-input') as HTMLInputElement;
    if (input) { input.value = ''; input.click(); }
  }

  /** Exporta os itens do pedido atual pra uma planilha .xlsx -- mesmo
   *  padrão do Pedido de Venda (exportarItensExcel lá): usa os nomes de
   *  coluna "PN" e "Quantidade" que o próprio Importar Itens já reconhece
   *  automaticamente (ver _detectarColunas acima), então um arquivo
   *  exportado daqui pode ser reimportado depois sem mapeamento manual. */
  exportarItensExcel(): void {
    const itensValidos = this.itens.filter(i => i.codprodInterno && i.codprodInterno > 0);
    if (itensValidos.length === 0) {
      this.abrirAlerta('Não há itens no pedido para exportar.', 'aviso');
      return;
    }

    const linhas = itensValidos.map(i => ({
      'PN':            i.codprod,
      'Descrição':     i.descricao,
      'UN':            i.unidade,
      'Quantidade':    i.quantidade,
      'Vl. Unit. U$':  i.precoUsd,
      'Vl. Unit. R$':  i.precoUnitario,
      'Custo U$':      i.precoUsd,
      'Total R$':      i.total,
    }));

    const ws = XLSX.utils.json_to_sheet(linhas);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Itens');
    const sufixo = this.nunotaAtual ? `_${this.nunotaAtual}` : '';
    XLSX.writeFile(wb, `Itens_PedidoCompra${sufixo}.xlsx`);
  }

  private _detectarColunas(headerRow: any[]): { colPn: number; colQty: number } {
    const norm = (s: any) => String(s ?? '').toUpperCase().replace(/[^A-Z0-9]/g, '');
    const aliasesPn  = new Set(['PN','PART','PARTNUMBER','PARTNUMBERS','PARTNO',
      'CODIGO','CÓDIGO','COD','REF','REFERENCIA','REFERÊNCIA','REFFORN','ITEM',
      'NUMEROPECA','NUMERODEPEÇA','CODPROD','PRODUTO']);
    const aliasesQty = new Set(['QUANTIDADE','QUANT','QTD','QTY','QTDE','QNT',
      'QUANTITY','QT','QDE','QTDE.','QUANT.']);
    let colPn = -1, colQty = -1;
    for (let i = 0; i < headerRow.length; i++) {
      const n = norm(headerRow[i]);
      if (colPn  === -1 && aliasesPn.has(n))  colPn  = i;
      if (colQty === -1 && aliasesQty.has(n)) colQty = i;
    }
    return { colPn, colQty };
  }

  private _parsearLinhasExcel(rows: any[][], colPn: number, colQty: number, startRow: number): ExcelImportRow[] {
    const linhas: ExcelImportRow[] = [];
    for (let i = startRow; i < rows.length; i++) {
      const row = rows[i];
      const pnRaw = String(row[colPn] ?? '').trim();
      if (!pnRaw) continue;
      const qty = Number(row[colQty]);
      linhas.push({ pn: pnRaw, quantidade: isNaN(qty) || qty <= 0 ? 1 : qty, status: 'pendente' });
    }
    return linhas;
  }

  async onExcelSelecionado(event: Event): Promise<void> {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (!file) return;

    this.excelImportNomeArquivo = file.name;
    this.excelImportLinhas     = [];
    this.excelImportAberto     = true;
    this.excelImportValidando  = true;
    this.excelMapeamentoAberto = false;

    try {
      const data = await file.arrayBuffer();
      const wb   = XLSX.read(data, { type: 'array' });
      const ws   = wb.Sheets[wb.SheetNames[0]];
      const rows: any[][] = XLSX.utils.sheet_to_json(ws, { header: 1, defval: '' });

      if (rows.length === 0) return;

      const { colPn, colQty } = this._detectarColunas(rows[0]);
      if (colPn !== -1 && colQty !== -1) {
        this.excelImportLinhas = this._parsearLinhasExcel(rows, colPn, colQty, 1);
        await this._validarPNsExcel();
      } else {
        this.excelRowsRaw       = rows;
        this.excelColunas       = rows[0].map((c: any, i: number) => {
          const label = String(c ?? '').trim();
          return label || `Coluna ${i + 1}`;
        });
        this.excelPreviewLinhas = rows.slice(1, 6);
        this.excelColunaPn      = null;
        this.excelColunaQty     = null;
        this.excelMapeamentoAberto = true;
      }
    } catch (e) {
      console.error('Erro ao ler Excel:', e);
      this.excelImportLinhas = [];
    } finally {
      this.excelImportValidando = false;
    }
  }

  async confirmarMapeamento(): Promise<void> {
    if (this.excelColunaPn === null || this.excelColunaQty === null) return;
    this.excelMapeamentoAberto = false;
    this.excelImportValidando  = true;
    try {
      this.excelImportLinhas = this._parsearLinhasExcel(
        this.excelRowsRaw, this.excelColunaPn, this.excelColunaQty, 1
      );
      await this._validarPNsExcel();
    } catch {
      this.excelImportLinhas = [];
    } finally {
      this.excelImportValidando = false;
    }
  }

  private async _validarPNsExcel(): Promise<void> {
    const normalizar = (s: string) => (s ?? '').toUpperCase().replace(/[.\-\/\s]/g, '');
    for (const linha of this.excelImportLinhas) {
      try {
        const res: any = await firstValueFrom(
          this.gateway.buscarProdutosEdicao({ REFFORN: linha.pn })
        );
        const lista: any[] = (res?.responseBody ?? res)?.lista ?? [];
        if (lista.length > 0) {
          const pnNorm = normalizar(linha.pn);
          const exato  = lista.find((p: any) => normalizar(p.refforn ?? '') === pnNorm);
          if (exato) {
            linha.status         = 'encontrado';
            linha.descricao      = exato.descricao ?? '';
            linha.codprodInterno = Number(exato.codprod ?? 0) || undefined;
            linha.codlocalpadrao = Number(exato.codlocalpadrao ?? 0) || 0;
            linha.prodData       = exato;
          } else {
            linha.status       = 'nao_encontrado';
            linha.proximosData = lista.slice(0, 8);
          }
        } else {
          linha.status = 'nao_encontrado';
        }
      } catch {
        linha.status = 'nao_encontrado';
      }
    }
  }

  toggleAproximados(linha: ExcelImportRow): void {
    this.excelAproximadosLinha = this.excelAproximadosLinha === linha ? null : linha;
  }

  selecionarAproximado(linha: ExcelImportRow, prod: any): void {
    linha.pn             = prod.refforn ?? linha.pn;
    linha.status         = 'encontrado';
    linha.descricao      = prod.descricao ?? '';
    linha.codprodInterno = Number(prod.codprod ?? 0) || undefined;
    linha.codlocalpadrao = Number(prod.codlocalpadrao ?? 0) || 0;
    linha.prodData       = prod;
    linha.proximosData   = undefined;
    this.excelAproximadosLinha = null;
  }

  get excelImportEncontrados(): number {
    return this.excelImportLinhas.filter(l => l.status === 'encontrado').length;
  }

  get excelImportNaoEncontrados(): number {
    return this.excelImportLinhas.filter(l => l.status === 'nao_encontrado').length;
  }

  async confirmarImportacaoExcel(): Promise<void> {
    if (this.excelImportNaoEncontrados > 0 && !this.excelAvisoNaoEncontrado) {
      this.excelAvisoNaoEncontrado = true;
      return;
    }
    this.excelAvisoNaoEncontrado = false;
    this.excelImportando = true;
    try {
      // PNs não encontrados → adiciona à observação
      const naoEncontrados = this.excelImportLinhas.filter(l => l.status === 'nao_encontrado');
      if (naoEncontrados.length > 0) {
        const bloco = `PNs não encontrados:\n${naoEncontrados.map(l => `${l.pn} - Qtd: ${l.quantidade}`).join('\n')}`;
        this.observacao = this.observacao ? `${this.observacao}\n${bloco}` : bloco;
      }
      // Remove linhas em branco e adiciona os itens encontrados
      this.itens = this.itens.filter(i => !!(i.codprod || i.descricao || i.codprodInterno));
      const encontrados = this.excelImportLinhas.filter(l => l.status === 'encontrado');
      const carregamentos: Promise<void>[] = [];
      for (const linha of encontrados) {
        const novo = this._novoItem();
        novo.codprod    = linha.pn;
        novo.quantidade = linha.quantidade;
        this.itens.push(novo);
        if (linha.prodData) {
          const p = linha.prodData;
          novo.descricao        = p.descricao ?? '';
          novo.codprodOriginal  = linha.pn;
          novo.unidade          = p.codvol ?? 'UN';
          novo.codprodInterno   = Number(p.codprod ?? 0) || undefined;
          novo.codlocalpadrao   = Number(p.codlocalpadrao ?? 0) || 0;
          carregamentos.push(this._buscarPrecoItem(novo));
        }
      }
      await Promise.all(carregamentos);
      this.onFiltroQtdeVendidaMudou();
    } finally {
      this.excelImportando  = false;
      this.excelImportAberto = false;
      this.excelImportLinhas = [];
    }
  }

  cancelarAvisoExcel(): void { this.excelAvisoNaoEncontrado = false; }

  fecharImportacaoExcel(): void {
    this.excelImportAberto     = false;
    this.excelImportLinhas     = [];
    this.excelAvisoNaoEncontrado = false;
    this.excelMapeamentoAberto = false;
    this.excelRowsRaw          = [];
    this.excelColunas          = [];
    this.excelPreviewLinhas    = [];
    this.excelColunaPn         = null;
    this.excelColunaQty        = null;
  }

  // ── Busca de Peças (F3 / Enter) ─────────────────────────────
  buscaPecasAberta        = false;
  buscaPecasTermo         = '';
  buscaPecasResultados: any[] = [];
  buscaPecasCarregando    = false;
  buscaPecasSemResultado  = false;
  buscaPecasProdutoSelecionado: any | null = null;
  buscaPecasLocais: { codLocal: number; codemp: number; nomeEmp: string; descrLocal: string; qtdTotal: number; qtdReservada: number; disponivel: number }[] = [];
  buscaPecasLocaisCarregando = false;
  private _buscaPecasItem: ItemCompra | null = null;
  private _buscaPecasSubject = new Subject<string>();

  // ── Produtos Alternativos (TGFPAL) — mesma lógica da Venda, sem preço ──────
  buscaPecasProdutoExpandido: any | null = null;
  buscaPecasAlternativos: any[] = [];
  buscaPecasAlternativosCarregando = false;

  // ── Ordenação da tabela de resultados (Busca de Peças / F3) — mesma da Venda ──
  buscaPecasOrdenarCampo: string | null = null;
  buscaPecasOrdemAsc = true;

  // ── Filtro por coluna (em tela, sobre os resultados já carregados) — mesma da Venda ──
  filtrosBusca: { [campo: string]: string } = {};
  colunaFiltroAberta: string | null = null;

  // Imagem do produto selecionado (painel lateral direito) + preview ampliado
  // — mesmo padrão do Pedido de Venda (F3), reaproveitando o mesmo endpoint
  // ProdutoGlobalSP.doBuscarImg já usado na Edição de Produtos.
  buscaPecasImagemUrl: string | null = null;
  buscaPecasImagemCarregando = false;
  private _buscaPecasImagemToken = 0;
  // Todas as imagens do produto (principal do TGFPRO + histórico do GPL_PRODUTOSIMG),
  // usadas para montar a faixa de miniaturas e navegar no preview ampliado.
  buscaPecasImagensExtras: string[] = [];
  buscaPecasImagemIndexAtivo = 0;
  imagemPreviewAberta = false;

  private _carregarImagemProdutoDetalhe(codprod: number): void {
    this.buscaPecasImagemUrl = null;
    this.buscaPecasImagensExtras = [];
    this.buscaPecasImagemIndexAtivo = 0;
    if (!codprod) { this.buscaPecasImagemCarregando = false; return; }
    this.buscaPecasImagemCarregando = true;
    const token = ++this._buscaPecasImagemToken;
    this.gateway.buscarImgProdutoEdicao({CODPROD: codprod}).subscribe({
      next: (res: any) => {
        if (token !== this._buscaPecasImagemToken) return;
        const body = res?.responseBody ?? res;
        const imagens: string[] = [];
        if (body?.principal) {
          imagens.push(`data:image/jpeg;base64,${body.principal}`);
        }
        for (const img of (body?.lista ?? [])) {
          if (img?.imagem) imagens.push(`data:image/jpeg;base64,${img.imagem}`);
        }
        this.buscaPecasImagensExtras = imagens;
        this.buscaPecasImagemIndexAtivo = 0;
        this.buscaPecasImagemUrl = imagens.length > 0 ? imagens[0] : null;
        this.buscaPecasImagemCarregando = false;
      },
      error: () => {
        if (token !== this._buscaPecasImagemToken) return;
        this.buscaPecasImagemUrl = null;
        this.buscaPecasImagensExtras = [];
        this.buscaPecasImagemIndexAtivo = 0;
        this.buscaPecasImagemCarregando = false;
      }
    });
  }

  abrirPreviewImagemBusca(): void {
    if (!this.buscaPecasImagemUrl) return;
    this.imagemPreviewAberta = true;
  }

  fecharPreviewImagemBusca(): void {
    this.imagemPreviewAberta = false;
  }

  /** Setas ←/→ navegam entre as imagens do produto quando o preview ampliado está aberto. */
  @HostListener('document:keydown.arrowleft')
  onArrowLeftImagemPreview(): void {
    if (this.imagemPreviewAberta) this.imagemPreviewNavegar(-1);
  }

  @HostListener('document:keydown.arrowright')
  onArrowRightImagemPreview(): void {
    if (this.imagemPreviewAberta) this.imagemPreviewNavegar(1);
  }

  /** Troca a imagem em destaque (painel lateral e preview ampliado) pela de índice `index`. */
  selecionarImagemBusca(index: number): void {
    if (index < 0 || index >= this.buscaPecasImagensExtras.length) return;
    this.buscaPecasImagemIndexAtivo = index;
    this.buscaPecasImagemUrl = this.buscaPecasImagensExtras[index];
  }

  /** Navega pra imagem anterior/próxima dentro do preview ampliado (quando há mais de uma). */
  imagemPreviewNavegar(passo: 1 | -1, event?: Event): void {
    event?.stopPropagation();
    const total = this.buscaPecasImagensExtras.length;
    if (total < 2) return;
    const novo = (this.buscaPecasImagemIndexAtivo + passo + total) % total;
    this.selecionarImagemBusca(novo);
  }

  /** Reseta o estado do modal de Busca de Peças e abre com o termo indicado
   *  (vazio = modal em branco). Fatorado de abrirBuscaPecas() pra ser
   *  reaproveitado também pelo preenchimento automático (buscarProdutoPorPN). */
  private _abrirModalBusca(item: ItemCompra, termoInicial: string): void {
    this._buscaPecasItem              = item;
    this.buscaPecasTermo              = termoInicial;
    this.buscaPecasResultados         = [];
    this.buscaPecasSemResultado       = false;
    this.buscaPecasProdutoSelecionado = null;
    this.buscaPecasLocais             = [];
    this.buscaPecasImagemUrl          = null;
    this.buscaPecasImagensExtras      = [];
    this.buscaPecasImagemIndexAtivo    = 0;
    this.imagemPreviewAberta          = false;
    this.buscaPecasProdutoExpandido       = null;
    this.buscaPecasAlternativos           = [];
    this.buscaPecasAlternativosCarregando = false;
    this.filtrosBusca                     = {};
    this.colunaFiltroAberta               = null;
    this.buscaPecasOrdenarCampo           = null;
    this.buscaPecasOrdemAsc               = true;
    this.buscaPecasAberta             = true;

    this._buscaPecasSubject.pipe(debounceTime(350), distinctUntilChanged())
      .subscribe(termo => this._executarBuscaPecas(termo));
  }

  /**
   * Enter ou F3 no campo PN. F3 sempre abre o modal de busca (mesmo padrão
   * do Pedido de Venda). Enter com PN digitado e produto ainda não
   * carregado tenta preencher DIRETO (buscarProdutoPorPN) -- só cai pro
   * modal se não achar exato ou achar mais de um -- pedido do usuário pra
   * não precisar abrir o F3 pra cada peça digitada.
   */
  abrirBuscaPecas(item: ItemCompra, event: Event): void {
    event.preventDefault();
    const pn   = (item.codprod ?? '').trim();
    const isF3 = (event as KeyboardEvent).key === 'F3';

    if (isF3) {
      this._abrirModalBusca(item, pn);
      setTimeout(() => {
        document.querySelector<HTMLInputElement>('.busca-pecas-input-unico')?.focus();
        if (pn) this._executarBuscaPecas(pn);
      }, 60);
      return;
    }

    // PN digitado diferente do carregado: refaz a consulta com o novo PN
    if (this._pnFoiAlterado(item)) {
      this._limparProdutoParaNovaBusca(item);
      this.buscarProdutoPorPN(item, event);
      return;
    }

    // Se o produto já está preenchido → foca QTD da mesma linha
    if (item.codprodInterno) {
      const idx = this.itens.indexOf(item);
      setTimeout(() => {
        const rows = document.querySelectorAll<HTMLElement>('.pcf-itens-table tbody tr');
        const qtd  = rows[idx]?.querySelector<HTMLInputElement>('.pcf-cell-qtd');
        qtd?.focus(); qtd?.select();
      }, 60);
      return;
    }

    // Enter com PN digitado e produto ainda não carregado → busca e preenche direto
    if (pn) {
      this.buscarProdutoPorPN(item, event);
      return;
    }

    // Enter vazio → abre modal de busca em branco
    this._abrirModalBusca(item, '');
    setTimeout(() => document.querySelector<HTMLInputElement>('.busca-pecas-input-unico')?.focus(), 60);
  }

  /**
   * Busca automática ao digitar o PN e sair do campo (Enter ou blur) --
   * igual ao Pedido de Venda (buscarProdutoPorPN lá), pedido do usuário
   * pra não precisar mais abrir o F3 pra cada peça. Só cai pro modal
   * quando: PN não encontrado (abre já com o termo buscado), ou há mais de
   * um resultado sem match exato (abre com os resultados já prontos, sem
   * buscar de novo, pro usuário escolher).
   */
  /** Produto já carregado mas o PN foi alterado no campo: limpa a linha (mantém a quantidade) para refazer a consulta. */
  private _pnFoiAlterado(item: ItemCompra): boolean {
    const pn = (item.codprod ?? '').trim();
    return !!item.codprodInterno && !!pn && !!item.codprodOriginal && pn !== item.codprodOriginal.trim();
  }

  private _limparProdutoParaNovaBusca(item: ItemCompra): void {
    const pn = item.codprod;
    const qtd = item.quantidade;
    const novo = this._novoItem();
    for (const k of Object.keys(item)) {
      if (k !== 'id') delete (item as any)[k];
    }
    Object.assign(item, novo, { id: item.id, codprod: pn, quantidade: qtd || 1 });
  }

  async buscarProdutoPorPN(item: ItemCompra, event: Event): Promise<void> {
    event.preventDefault();
    const pn = (item.codprod ?? '').trim();
    if (!pn) return;

    // Trava de reentrância -- mesmo motivo do Pedido de Venda: desabilitar
    // o campo com foco (via [disabled]="!!item.buscando" no template)
    // dispara um blur automático, que chamaria onPnBlur -> essa mesma
    // busca de novo, em paralelo com a primeira.
    if (item.buscando) return;

    item.buscando = true;
    try {
      const codemp = Number(this.empresaState.codEmpReal) || undefined;
      const res: any = await firstValueFrom(this.gateway.buscarPecasModal({ REFFORN: pn, CODEMP: codemp }));
      const lista: any[] = (res?.responseBody ?? res)?.lista ?? [];

      if (lista.length === 0) {
        // PN não encontrado → abre modal com o termo pré-preenchido e busca disparada
        this._abrirModalBusca(item, pn);
        setTimeout(() => {
          document.querySelector<HTMLInputElement>('.busca-pecas-input-unico')?.focus();
          this._executarBuscaPecas(pn);
        }, 60);
        return;
      }

      if (lista.length > 1) {
        // Mais de um produto — verifica se algum é match exato do PN digitado
        // (mesma normalização usada na busca em si -- ver normalizarPn() no addon GPL).
        const normalizar = (s: string) => (s ?? '').toUpperCase().replace(/[.\-\/\s]/g, '');
        const pnNorm = normalizar(pn);
        const exatos = lista.filter((p: any) => normalizar(p.refforn ?? '') === pnNorm);
        if (exatos.length === 1) {
          this._selecionarProdutoDireto(item, exatos[0]);
          return;
        }
        // Zero exatos (só parecidos) ou múltiplos com o mesmo PN → abre modal
        // já com os resultados prontos (exatos primeiro), sem buscar de novo.
        lista.sort((a: any, b: any) => {
          const aExato = normalizar(a.refforn) === pnNorm ? 0 : 1;
          const bExato = normalizar(b.refforn) === pnNorm ? 0 : 1;
          return aExato - bExato;
        });
        this._abrirModalBusca(item, pn);
        this.buscaPecasResultados = lista;
        setTimeout(() => document.querySelector<HTMLInputElement>('.busca-pecas-input-unico')?.focus(), 60);
        return;
      }

      this._selecionarProdutoDireto(item, lista[0]);
    } catch (err) {
      console.error('[PedidoCompra] erro ao buscar produto por PN:', err);
      this.abrirAlerta('Erro ao buscar produto.', 'erro');
    } finally {
      item.buscando = false;
    }
  }

  /** Preenche o item direto com o produto achado, sem passar pelo modal --
   *  mesmo preenchimento usado ao confirmar manualmente no F3
   *  (_preencherItem), só ajustando o PN pro formato exato vindo do banco
   *  antes (com traços/pontuação certos, igual confirmarSelecaoPeca). */
  private _selecionarProdutoDireto(item: ItemCompra, prod: any): void {
    item.codprod = prod.refforn ?? prod.referencia ?? String(prod.codprod ?? '');
    this._preencherItem(item, prod);
  }

  onBuscaPecasInput(): void {
    this._buscaPecasSubject.next(this.buscaPecasTermo);
  }

  private async _executarBuscaPecas(termo: string): Promise<void> {
    const t = termo.trim();
    if (t.length < 2) {
      this.buscaPecasResultados         = [];
      this.buscaPecasSemResultado       = false;
      this.buscaPecasProdutoSelecionado = null;
      this.buscaPecasLocais             = [];
      this.buscaPecasImagemUrl          = null;
      this.buscaPecasImagensExtras      = [];
      this.buscaPecasImagemIndexAtivo    = 0;
      this.buscaPecasProdutoExpandido   = null;
      return;
    }
    this.buscaPecasCarregando         = true;
    this.buscaPecasSemResultado       = false;
    this.buscaPecasProdutoSelecionado = null;
    this.buscaPecasLocais             = [];
    this.buscaPecasImagemUrl          = null;
    this.buscaPecasImagensExtras      = [];
    this.buscaPecasImagemIndexAtivo    = 0;
    this.buscaPecasProdutoExpandido   = null;
    this.filtrosBusca                 = {}; // nova busca zera filtros de coluna anteriores
    try {
      const codemp = Number(this.empresaState.codEmpReal) || undefined;
      // 1ª tentativa por PN
      const resPN: any = await firstValueFrom(this.gateway.buscarPecasModal({ REFFORN: t, CODEMP: codemp }));
      const listaPN: any[] = (resPN?.responseBody ?? resPN)?.lista ?? [];
      if (listaPN.length > 0) {
        this.buscaPecasResultados   = listaPN;
        this.buscaPecasSemResultado = false;
        // O primeiro resultado já vem selecionado (estoque, imagem e alternativos carregam sozinhos).
        this.selecionarProdutoParaDetalhe(listaPN[0]);
        return;
      }
      // 2ª tentativa por descrição
      const resDesc: any = await firstValueFrom(this.gateway.buscarPecasModal({ DESCRICAO: t, CODEMP: codemp }));
      const listaDesc: any[] = (resDesc?.responseBody ?? resDesc)?.lista ?? [];
      this.buscaPecasResultados   = listaDesc;
      this.buscaPecasSemResultado = listaDesc.length === 0;
      if (listaDesc.length > 0) this.selecionarProdutoParaDetalhe(listaDesc[0]);
    } catch {
      this.buscaPecasSemResultado = true;
    } finally {
      this.buscaPecasCarregando = false;
    }
  }

  async selecionarProdutoParaDetalhe(prod: any): Promise<void> {
    // Guarda: um duplo-clique dispara click, click, dblclick em sequência no navegador.
    // Sem esta guarda, este método reseta e refaz o fetch duas vezes antes do dblclique
    // ser processado, causando a "tela tremendo" durante o duplo-clique (mesmo fix da Venda).
    if (this.buscaPecasProdutoSelecionado === prod) return;

    this.buscaPecasProdutoSelecionado = prod;
    // Fixa o produto principal expandido — a sub-lista de alternativos usa este
    // campo (não buscaPecasProdutoSelecionado) para permanecer visível mesmo
    // quando o usuário depois clica em um dos alternativos abaixo.
    this.buscaPecasProdutoExpandido       = prod;
    this.buscaPecasLocais                 = [];
    this.buscaPecasLocaisCarregando       = true;
    this.buscaPecasAlternativos           = [];
    this.buscaPecasAlternativosCarregando = true;
    const codprodImg = Number(prod.codprod);
    this._carregarImagemProdutoDetalhe(codprodImg);
    const codprod = Number(prod.codprod);
    if (!codprod) {
      this.buscaPecasLocaisCarregando       = false;
      this.buscaPecasAlternativosCarregando = false;
      return;
    }
    try {
      const res: any = await firstValueFrom(this.gateway.buscarEstoquePorLocal(codprod));
      const todos: any[] = (res?.responseBody ?? res)?.locais ?? [];
      this.buscaPecasLocais = todos.filter(
        l => (l.qtdTotal ?? 0) !== 0 || (l.qtdReservada ?? 0) !== 0 || (l.disponivel ?? 0) !== 0
      );
    } catch { }
    finally { this.buscaPecasLocaisCarregando = false; }

    // Alternativos TGFPAL (fire-and-forget) -- mesma chamada genérica da Venda.
    const codEmpAlt = Number(this.empresaState.codEmpReal) || undefined;
    this.gateway.buscarAlternativosProduto(codprod, codEmpAlt).subscribe({
      next: (res: any) => {
        const body = res?.responseBody ?? res;
        this.buscaPecasAlternativos           = body?.lista ?? [];
        this.buscaPecasAlternativosCarregando = false;
      },
      error: () => { this.buscaPecasAlternativosCarregando = false; }
    });
  }

  /** Clique em um dos alternativos da sub-lista — mostra estoque/imagem dele, mas
   *  mantém a sub-lista de alternativos do produto PRINCIPAL visível (não usa
   *  buscaPecasProdutoExpandido, que continua apontando pro item de cima). */
  async selecionarAlternativoParaDetalhe(alt: any): Promise<void> {
    if (this.buscaPecasProdutoSelecionado === alt) return;
    this.buscaPecasProdutoSelecionado = alt;
    this.buscaPecasLocais             = [];
    this.buscaPecasLocaisCarregando   = true;
    const codprod = Number(alt.codprod);
    this._carregarImagemProdutoDetalhe(codprod);
    if (!codprod) { this.buscaPecasLocaisCarregando = false; return; }
    try {
      const res: any = await firstValueFrom(this.gateway.buscarEstoquePorLocal(codprod));
      const todos: any[] = (res?.responseBody ?? res)?.locais ?? [];
      this.buscaPecasLocais = todos.filter(
        l => (l.qtdTotal ?? 0) !== 0 || (l.qtdReservada ?? 0) !== 0 || (l.disponivel ?? 0) !== 0
      );
    } catch { }
    finally { this.buscaPecasLocaisCarregando = false; }
  }

  // ── Valores de venda (R$/U$ + IPI) na Busca de Peças — mesma lógica da Venda ──

  /**
   * Converte Valor Moeda → Valor R$ na tela de Busca de Peças (F3), principal
   * e alternativos. Sempre multiplica pela cotação do dia.
   */
  valorEmReaisBusca(vlrVenda: number | null | undefined, _origemNacional: boolean | null | undefined, cotacao: number): number | null {
    if (vlrVenda == null) return null;
    return cotacao > 0 ? vlrVenda * cotacao : null;
  }

  /** Valor unitário do IPI (R$) do produto na Busca de Peças — preço R$ × alíquota IPI
   *  (a alíquota já vem no resultado da busca, via JOIN com TGFIPI no backend). */
  vlrIpiUnitarioBusca(p: any, cotacao: number): number {
    const precoBrl = this.valorEmReaisBusca(p?.vlrVenda, p?.origemNacional, cotacao);
    const aliq = parseFloat(String(p?.aliqIpi ?? p?.aliq_ipi ?? '0').replace(',', '.')) || 0;
    return precoBrl != null && aliq > 0 ? parseFloat((precoBrl * aliq / 100).toFixed(2)) : 0;
  }

  /** Custo (R$) na Busca de Peças = Preço do Fabricante (TGFPRO.VLRCOMERC, U$) x cotação do dia
   *  (fabricante nacional: o preço já é R$). Sem vlrComerc na resposta (addon antigo): custo de reposição. */
  custoReaisBusca(p: any): number | null {
    if (p && p.vlrComerc !== undefined) {
      const f = Number(p.vlrComerc);
      if (!(f > 0)) return null;
      if (p.origemNacional) return parseFloat(f.toFixed(2));
      const taxa = this.cotacaoValorNumerico;
      return taxa > 0 ? parseFloat((f * taxa).toFixed(2)) : null;
    }
    const c = Number(p?.custo);
    return c > 0 ? parseFloat(c.toFixed(2)) : null;
  }

  /** Custo (U$) na Busca de Peças = Preço do Fabricante (TGFPRO.VLRCOMERC). */
  custoMoedaBusca(p: any, cotacao: number): number | null {
    if (p && p.vlrComerc !== undefined) {
      const f = Number(p.vlrComerc);
      if (!(f > 0)) return null;
      if (p.origemNacional) return cotacao > 0 ? parseFloat((f / cotacao).toFixed(2)) : null;
      return parseFloat(f.toFixed(2));
    }
    const c = Number(p?.custo);
    return c > 0 && cotacao > 0 ? parseFloat((c / cotacao).toFixed(2)) : null;
  }

  /** Valor Moeda (U$) já somado o IPI unitário (IPI é sempre em R$, convertido pela cotação). */
  valorMoedaComIpiBusca(p: any, cotacao: number): number | null {
    if (p?.vlrVenda == null) return null;
    const ipiUsd = cotacao > 0 ? this.vlrIpiUnitarioBusca(p, cotacao) / cotacao : 0;
    return parseFloat((p.vlrVenda + ipiUsd).toFixed(2));
  }

  /** Valor R$ já somado o IPI unitário. */
  valorReaisComIpiBusca(p: any, cotacao: number): number | null {
    const precoBrl = this.valorEmReaisBusca(p?.vlrVenda, p?.origemNacional, cotacao);
    if (precoBrl == null) return null;
    return parseFloat((precoBrl + this.vlrIpiUnitarioBusca(p, cotacao)).toFixed(2));
  }

  /** Converte "dd/MM/yyyy" num número comparável (yyyyMMdd) pra ordenar por data
   *  sem depender de new Date(str), que é ambíguo entre browsers/locales. */
  private _dataBrParaOrdenacao(dataBr: string | null | undefined): number | null {
    if (!dataBr) return null;
    const partes = dataBr.split('/');
    if (partes.length !== 3) return null;
    const dd = parseInt(partes[0], 10), mm = parseInt(partes[1], 10), yyyy = parseInt(partes[2], 10);
    if (!dd || !mm || !yyyy) return null;
    return yyyy * 10000 + mm * 100 + dd;
  }

  // ── Filtro/ordenação por coluna (mesma lógica da Venda) ──

  /** Resultados exibidos na tabela: buscaPecasResultados após aplicar os
   *  filtros de coluna ativos em filtrosBusca. Não muta buscaPecasResultados
   *  (a ordenação continua funcionando normalmente sobre a lista completa). */
  get buscaPecasResultadosExibidos(): any[] {
    const campos = Object.keys(this.filtrosBusca).filter(c => (this.filtrosBusca[c] || '').trim().length > 0);
    if (campos.length === 0) return this.buscaPecasResultados;
    return this.buscaPecasResultados.filter(p => campos.every(campo => {
      const termo = this.filtrosBusca[campo].trim().toLowerCase();
      const valor = this._valorOrdenacaoBusca(p, campo);
      return String(valor ?? '').toLowerCase().includes(termo);
    }));
  }

  limparFiltroBusca(campo: string, event?: Event): void {
    event?.stopPropagation();
    delete this.filtrosBusca[campo];
  }

  temFiltroBusca(campo: string): boolean {
    return !!(this.filtrosBusca[campo] || '').trim();
  }

  toggleFiltroBusca(campo: string, event?: Event): void {
    event?.stopPropagation();
    this.colunaFiltroAberta = this.colunaFiltroAberta === campo ? null : campo;
    if (this.colunaFiltroAberta === campo) {
      setTimeout(() => document.getElementById('filtro-busca-compra-' + campo)?.focus(), 0);
    }
  }

  /** Fecha o campo de digitação ao perder o foco/Enter — o filtro
   *  continua aplicado normalmente, só o input inline é que recolhe. */
  fecharFiltroBusca(): void {
    this.colunaFiltroAberta = null;
  }

  ordenarBuscaPecas(campo: string): void {
    if (this.buscaPecasOrdenarCampo === campo) {
      this.buscaPecasOrdemAsc = !this.buscaPecasOrdemAsc;
    } else {
      this.buscaPecasOrdenarCampo = campo;
      this.buscaPecasOrdemAsc = true;
    }
    const dir = this.buscaPecasOrdemAsc ? 1 : -1;
    this.buscaPecasResultados = [...this.buscaPecasResultados].sort((a, b) => {
      const va = this._valorOrdenacaoBusca(a, campo);
      const vb = this._valorOrdenacaoBusca(b, campo);
      if (va == null && vb == null) return 0;
      if (va == null) return 1;  // sem valor sempre por último, nas duas direções
      if (vb == null) return -1;
      if (typeof va === 'string' && typeof vb === 'string') return va.localeCompare(vb, 'pt-BR') * dir;
      return ((va as number) - (vb as number)) * dir;
    });
  }

  private _valorOrdenacaoBusca(p: any, campo: string): string | number | null {
    switch (campo) {
      case 'pn':          return String(p.refforn ?? p.referencia ?? p.codprod ?? '');
      case 'cd':           return String(p.condicao ?? '');
      case 'descricao':    return String(p.descricao ?? '');
      case 'alternativo':  return String(p.alternativo ?? '');
      case 'un':           return String(p.codvol ?? '');
      case 'estoque':      return p.estoque ?? 0;
      case 'valorMoedaIpi': return this.custoMoedaBusca(p, this.cotacaoValorNumerico);
      case 'valorReaisIpi': return this.custoReaisBusca(p);
      case 'vlrIpi':        return this.vlrIpiUnitarioBusca(p, this.cotacaoValorNumerico);
      case 'fabricante':    return String(p.marca ?? '');
      case 'dataUltAtual':  return this._dataBrParaOrdenacao(p.dataUltAtualPreco);
      case 'limiteDias':    return p.limitePrazoAtualDias > 0 ? p.limitePrazoAtualDias : null;
      case 'codigo':        return p.codprod ?? null;
      default:              return null;
    }
  }

  confirmarSelecaoPeca(): void {
    const prod = this.buscaPecasProdutoSelecionado;
    if (!prod || !this._buscaPecasItem) return;
    this._buscaPecasItem.codprod = prod.refforn ?? prod.referencia ?? String(prod.codprod ?? '');
    this._preencherItem(this._buscaPecasItem, prod);
    this.fecharBuscaPecas();
  }

  selecionarPecaModal(prod: any): void {
    if (this._buscaPecasItem) {
      this._buscaPecasItem.codprod = prod.refforn ?? prod.referencia ?? String(prod.codprod ?? '');
      this._preencherItem(this._buscaPecasItem, prod);
    }
    this.fecharBuscaPecas();
  }

  fecharBuscaPecas(): void {
    this.buscaPecasAberta             = false;
    this._buscaPecasItem              = null;
    this.buscaPecasResultados         = [];
    this.buscaPecasTermo              = '';
    this.buscaPecasProdutoSelecionado = null;
    this.buscaPecasLocais             = [];
    this.buscaPecasImagemUrl          = null;
    this.buscaPecasImagensExtras      = [];
    this.buscaPecasImagemIndexAtivo    = 0;
    this.imagemPreviewAberta          = false;
    this.buscaPecasProdutoExpandido       = null;
    this.buscaPecasAlternativos           = [];
    this.buscaPecasAlternativosCarregando = false;
    this.filtrosBusca                     = {};
    this.colunaFiltroAberta               = null;
    this.buscaPecasOrdenarCampo           = null;
    this.buscaPecasOrdemAsc               = true;
  }

  buscaTotalLocais(campo: 'qtdTotal' | 'qtdReservada' | 'disponivel'): number {
    return this.buscaPecasLocais.reduce((acc, l) => acc + ((l[campo] as number) ?? 0), 0);
  }

  corLinhaEstoque(codemp: number): string {
    const cores: Record<string, string> = { '1': '#dbeafe', '2': '#dcfce7', '3': '#fef9c3', '4': '#fce7f3' };
    return cores[String(codemp)] ?? '';
  }

  private _preencherItem(item: ItemCompra, prod: any): void {
    item.descricao        = prod.descricao ?? '';
    item.codprodOriginal  = item.codprod;
    item.unidade          = prod.codvol ?? 'UN';
    item.codprodInterno   = prod.codprod ? Number(prod.codprod) : undefined;
    item.codlocalpadrao   = prod.codlocalpadrao ? Number(prod.codlocalpadrao) : 0;
    this._buscarPrecoItem(item);
    this.onFiltroQtdeVendidaMudou();
  }

  private async _buscarPrecoItem(item: ItemCompra): Promise<void> {
    await this._carregarPrecoEstoqueItem(item);

    // Produto encontrado → foca QTD da linha atual (nova linha só é criada ao dar Enter na QTD)
    // Só faz sentido pro fluxo de 1 item por vez (digitar PN, importar Excel
    // linha a linha) -- import em massa (Funções > Peças com Venda) chama
    // _carregarPrecoEstoqueItem() direto, sem essa parte, pra não ficar
    // fazendo querySelectorAll na tabela inteira centenas/milhares de vezes.
    const idx = this.itens.indexOf(item);
    setTimeout(() => {
      const rows = document.querySelectorAll<HTMLElement>('.pcf-itens-table tbody tr');
      const qtd  = rows[idx]?.querySelector<HTMLInputElement>('.pcf-cell-qtd');
      qtd?.focus(); qtd?.select();
    }, 60);
  }

  /** Núcleo de _buscarPrecoItem() sem a parte de foco/DOM -- busca preço
   *  (PedidoVendaGlobalSP.doBuscarPrecoExc) e dispara a atualização de
   *  estoque pro item. Usado tanto por _buscarPrecoItem() (fluxo de 1 item)
   *  quanto direto pelo import em massa da "Funções > Peças com Venda". */
  /** Trocou a empresa: o local do estoque é por empresa -- recarrega os locais de todos os itens. */
  private _subEmpresaMudou?: Subscription;

  private _recarregarLocaisDosItens(): void {
    if (this.carregandoEdicao) return;
    for (const it of this.itens) {
      if (!it.codprodInterno) continue;
      it.localSel = undefined;
      it.locaisOpcoes = [];
      void this._carregarLocaisItem(it);
    }
  }

  // ── Local do estoque do item (Sankhya TGFEST/TGFLOC) + local do Aerosys (informativo) ──
  /** Sem local com saldo -> Local Coringa (TGFLOC 95000000). */
  private readonly LOCAL_CORINGA = 95000000;

  /**
   * Carrega os locais do produto na empresa. Pré-seleciona o da ENTRADA MAIS RECENTE (a pessoa pode trocar,
   * inclusive escolher "FIFO" = local da entrada mais antiga com saldo). Sem local com saldo: Coringa.
   * Se o usuário já escolheu (ou veio da edição), mantém a escolha.
   */
  private async _carregarLocaisItem(item: ItemCompra): Promise<void> {
    if (!item.codprodInterno) return;
    const codemp = parseInt(this.empresaState.codEmpReal ?? '0', 10) || 0;
    try {
      const res: any = await firstValueFrom(
        this.gateway.buscarLocaisParaItem(item.codprodInterno, codemp, item.localSel).pipe(timeout(12000))
      );
      const body = res?.responseBody ?? res;
      const lista: any[] = body?.locais ?? [];
      item.locaisOpcoes = lista.map(l => ({
        codLocal:   Number(l.codLocal),
        descrLocal: String(l.descrLocal ?? ''),
        estoque:    Number(l.estoque ?? 0),
        dtEntrada:  String(l.dtEntrada ?? ''),
      }));
      const atual = item.localSel;
      if (atual && !item.locaisOpcoes.some(o => o.codLocal === atual)) {
        item.locaisOpcoes.push({ codLocal: atual, descrLocal: 'Local atual', estoque: 0, dtEntrada: '' });
      }
      const valido = !!atual;
      if (!valido) {
        this.aplicarOrdemLocal(item, item.localOrdem ?? 'RECENTE');
      }
    } catch {
      if (item.localSel == null) item.localSel = this.LOCAL_CORINGA;
    }
    // garante que o valor selecionado (ex.: Coringa) sempre exista como opção do seletor
    item.locaisOpcoes = item.locaisOpcoes ?? [];
    if (item.localSel && !item.locaisOpcoes.some(o => o.codLocal === item.localSel)) {
      item.locaisOpcoes.push({ codLocal: item.localSel, descrLocal: item.localSel === this.LOCAL_CORINGA ? 'LOCAL CORINGA' : 'Local atual', estoque: 0, dtEntrada: '' });
    }
    // Local do Aerosys (texto, ex.: 1-A-1) -- só para consulta
    try {
      const est: any = await firstValueFrom(
        this.gateway.buscarEstoqueAerosys(item.codprodInterno, codemp || undefined).pipe(timeout(12000))
      );
      item.localAerosys = String(est?.local ?? '').trim();
    } catch { /* informativo */ }
  }

  /**
   * Consulta FIFO: escolhe, entre os locais com saldo, o da entrada MAIS ANTIGA ('FIFO') ou MAIS RECENTE ('RECENTE').
   * Sem local com saldo -> Coringa. O botão "FIFO" ao lado do seletor alterna entre as duas ordens.
   */
  aplicarOrdemLocal(item: ItemCompra, ordem: 'RECENTE' | 'FIFO'): void {
    item.localOrdem = ordem;
    const c = (item.locaisOpcoes ?? [])
      .filter(o => o.codLocal !== this.LOCAL_CORINGA)
      .sort((a, b) => ordem === 'FIFO'
        ? (a.dtEntrada || '9999').localeCompare(b.dtEntrada || '9999')
        : (b.dtEntrada || '').localeCompare(a.dtEntrada || ''));
    item.localSel = c.length > 0 ? c[0].codLocal : this.LOCAL_CORINGA;
  }

  alternarFifoLocal(item: ItemCompra): void {
    this.aplicarOrdemLocal(item, item.localOrdem === 'FIFO' ? 'RECENTE' : 'FIFO');
  }

  private _codLocalDoItem(item: ItemCompra): number {
    return Number(item.localSel) || Number(item.codlocalpadrao) || this.LOCAL_CORINGA;
  }

  private async _carregarPrecoEstoqueItem(item: ItemCompra): Promise<void> {
    if (!item.codprodInterno) return;
    void this._carregarLocaisItem(item);
    const codemp = parseInt(this.empresaState.codEmpReal ?? '0', 10) || 0;
    try {
      // timeout -- num import em massa de milhares de itens, 1 chamada que
      // nunca responde (nem sucesso nem erro) travava o Promise.all() do
      // lote inteiro pra sempre, e a importação ficava presa em "Importando..."
      // sem nunca terminar. Com timeout, essa chamada falha depois de 12s
      // (cai no catch, item fica sem preço) e a importação segue em frente.
      const res: any = await firstValueFrom(
        this.gateway.buscarPrecoExc(item.codprodInterno, codemp).pipe(timeout(12000))
      );
      const body = res?.responseBody ?? res;
      const info = body?.info ?? body;
      // Pedido de COMPRA: o custo é o Preço do Fabricante (TGFPRO.VLRCOMERC,
      // em U$) -- não o preço de venda (TGFEXC.VLRVENDA).
      const vlrFab = parseFloat(String(info?.vlrComerc ?? '0').replace(',', '.')) || 0;

      // Fabricante NACIONAL (FABNAC, como na Venda): o Preço do Fabricante já
      // é R$ -- não multiplica pela cotação; U$ = R$ ÷ cotação do dia.
      await this._resolverNacional(item);
      const taxa = this.cotacaoValorNumerico;
      if (item.fabricanteNacional) {
        item.precoUnitario = parseFloat(vlrFab.toFixed(2));
        item.precoBrlStr   = item.precoUnitario > 0 ? this.fmtDecimal(item.precoUnitario) : '';
        item.precoUsd      = taxa > 0 ? parseFloat((item.precoUnitario / taxa).toFixed(2)) : 0;
        item.precoUsdStr   = item.precoUsd > 0 ? this.fmtMoeda(item.precoUsd) : '';
      } else {
        item.precoUsd    = vlrFab;
        item.precoUsdStr = vlrFab > 0 ? this.fmtMoeda(vlrFab) : '';
        if (taxa > 0) {
          item.precoUnitario = parseFloat((vlrFab * taxa).toFixed(2));
        }
      }
      this._calcularTotal(item);
      this._atualizarEstoque(item);
    } catch {/* ignora */ }
  }

  /** Enter na QTD → cria próxima linha (se for a última) e foca o PN dela */
  confirmarItemCompra(item: ItemCompra, event: Event): void {
    event.preventDefault();
    const idx    = this.itens.indexOf(item);
    const isLast = idx === this.itens.length - 1;
    if (isLast) {
      this.adicionarLinha();
    }
    setTimeout(() => {
      const rows = document.querySelectorAll<HTMLElement>('.pcf-itens-table tbody tr');
      rows[idx + 1]?.querySelector<HTMLInputElement>('.pcf-cell-pn')?.focus();
    }, 60);
  }

  private async _atualizarEstoque(item: ItemCompra): Promise<void> {
    if (!item.codprodInterno) return;
    const codemp = parseInt(this.empresaState.codEmpReal ?? '0', 10) || 0;
    try {
      const res: any = await firstValueFrom(
        this.gateway.buscarEstoquePorLocal(item.codprodInterno).pipe(timeout(12000))
      );
      const lista: any[] = (res?.responseBody ?? res)?.locais ?? [];
      let total = 0;
      for (const loc of lista) {
        const emp = parseInt(String(loc.codemp ?? '0'), 10);
        if (codemp > 0 && emp !== codemp) continue;
        total += parseFloat(String(loc.disponivel ?? '0').replace(',', '.')) || 0;
      }
      item.estoque = parseFloat(total.toFixed(3));
    } catch {/* ignora */ }
  }

  onPnBlur(item: ItemCompra, event: FocusEvent): void {
    const rel = event.relatedTarget as HTMLElement | null;
    if (rel?.closest?.('.pcf-busca-pecas-modal')) return;
    const pn = (item.codprod ?? '').trim();
    if (!pn) {
      if (item.codprodInterno || item.descricao) {
        item.codprodInterno = undefined;
        item.descricao      = '';
        this.abrirAlerta('PN apagado. Digite o PN e pressione ENTER para buscar.', 'aviso');
      }
      return;
    }
    if (this._pnFoiAlterado(item)) {
      this._limparProdutoParaNovaBusca(item);
    } else if (item.codprodInterno) {
      return;
    }
    this.buscarProdutoPorPN(item, event as unknown as Event);
  }

  // ── Formulário válido ───────────────────────────────────────
  get formularioValido(): boolean {
    return !!this.fornecedorSelecionado && !!this.dataEmissao;
  }

  // ── Salvar ──────────────────────────────────────────────────
  async salvar(): Promise<void> {
    if (this.somenteLeitura) return;
    if (this.salvando()) return;                    // guard contra duplo clique
    if (!this.formularioValido) {
      this.abrirAlerta('Preencha o Fornecedor e a Data de Emissão.', 'aviso');
      return;
    }
    if (this.itensValidos.length === 0) {
      this.abrirAlerta('Adicione pelo menos um item com PN válido.', 'aviso');
      return;
    }

    this.salvando.set(true);
    try {
      const payload: any = {
        cabecalho: {
          codEmp:      Number(this.empresaState.codEmpReal ?? 1),
          // Empresa VIRTUAL (ex.: 12 = Aero LLC): TGFCAB.CODEMP leva a real; a virtual vai em GPL_EMPRESA_VIRTUAL.
          empresaVirtual: this.empresaState.selecionadaEhVirtual ? Number(this.empresaState.selecionada) : 0,
          codParc:     Number(this.fornecedorSelecionado!.codparc),
          codTipOper:  this.COD_TIP_OPER,
          // Parceiro importador (TGFCAB.CODPARCIMP): só nas TOPs de importação (1323), = fornecedor
          codParcImp:  this.tipoGpl !== 'NACIONAL' ? Number(this.fornecedorSelecionado!.codparc) : null,
          codTipVenda: Number(this.tipoNegociacaoSelecionado || 1),
          codCenCus:   Number(this.centroResultadoSelecionado ?? 0),
          codProj:     Number(this.projetoSelecionado ?? 0),
          codNat:      Number(this.naturezaSelecionada ?? 0),
          observacao:  this.observacao ?? '',
          obsInterna:  this.observacaoInterna ?? '',
          adObs:       '',
          adFreteObs:  '',
          numPedido2:  this.numPedido2 ?? '',
          qtdeVendidaDe:  this.qtdeVendidaDtDe,
          qtdeVendidaAte: this.qtdeVendidaDtAte,
          mantemCotacao: 'S',
          tipoNumTitulo: 'PC',
          codVend:     this.compradorSelecionado ? Number(this.compradorSelecionado) : null,
          dataEmissao: this._isoToBr(this.dataEmissao),
          dtPrevent:   this._isoToBr(this.dtPrevent),
          dtNegociacao: this._isoToBr(this.dataEmissao),
          tipFrete:    '',
          codParcTransp: null,
          cifFob:      '',
          formaEnvio:  '',
          qtdVol:      null,
          pesoBruto:   null,
          vlrFrete:    null,
          vlrFreteTtl: null,
          prioridade:  this.prioridadeSelecionada || '',
          despachar:   '',
          fatImediato: '',
          tipoGpl:     this.tipoGpl ?? '',
          // Na edição mantém o status atual (AUTORIZADO etc.): regravar 'ABERTO' desfaria a autorização.
          gplStatus:   (this.modoEdicao && this.gplStatusAtual) ? this.gplStatusAtual : 'ABERTO',
          codAero:     null,
          codParcDest: null,
          vlrMoeda:    this.cotacaoValorNumerico || null,
          vlrDescTot:  null,
          percDesc:    null,
        },
        itens: this.itensValidos.map(i => ({
          codprod:       i.codprodInterno!,
          codvol:        (i.unidade || 'UN').trim(),
          qtdneg:        i.quantidade || 1,
          vlrunit:       i.precoUnitario || 0,
          percdesc:      Math.abs(i.desconto || 0),
          vlrdesc:       (i.vlrDesc || 0) > 0 ? (i.vlrDesc || 0) : 0,
          vlracrescdesc: (i.vlrDesc || 0) < 0 ? Math.abs(i.vlrDesc || 0) : (i.vlrAcrescDesc || 0),
          codlocal:      this._codLocalDoItem(i),
          vlrtot:        i.total || 0,
          // U$: mesmo padrão da Venda (addon grava em TGFITE.VLRUNITMOE / VLRTOTMOE)
          obsItem:       (i.obs || '').trim(),
          statusItem:    i.statusItem || 'ABERTO',
          vlrunitmoe:    i.precoUsd || 0,
          vlrtotmoe:     i.totalUsd || 0,
          vlripi:        0,
          vlrsubst:      0,
          ad_core:       'N',
          ad_vlrcore:    0,
          // Round-trip da correlação com o item no Aerosys (gravada na
          // criação, ver GPL_IDITEMAEROSYS) -- precisa vir de volta no save
          // pra sincronizarEdicaoNoAerosys conseguir localizar o item numa
          // segunda edição do mesmo pedido.
          idItemAerosys: i.idItemAerosys || undefined,
        })),
      };

      const isCriacao = !(this.modoEdicao && this.nunotaAtual);
      if (!isCriacao) {
        payload.cabecalho.nunota = this.nunotaAtual;
      }

      // Criação E edição passam pelo endpoint dedicado: ele valida/corrige os itens, grava no Sankhya e
      // espelha/sincroniza no Aerosys (criação: cria o pedido; edição: atualiza cabeçalho, solicitante e itens).
      const res: any = await firstValueFrom(this.gateway.gravarPedidoCompra(payload));

      const sankhyaBody: any = res?.sankhya?.responseBody ?? res?.sankhya ?? res;

      // Mais de 100 itens: o backend dividiu em vários pedidos (000001/27-1, -2, ...).
      const partes: any[] = Array.isArray(res?.partes) ? res.partes : [];
      if (isCriacao && partes.length > 0) {
        const gravadas = partes.filter(p => p?.sucesso);
        const falha = partes.find(p => !p?.sucesso);
        const lista = gravadas.map(p => `${p.numTitulo} (NUNOTA ${p.nunota}, ${p.itens} itens)`).join('; ');
        if (falha) {
          this.abrirAlerta(`Pedido dividido: ${gravadas.length} parte(s) gravada(s)${lista ? ' — ' + lista : ''}. A parte ${falha.parte} (${falha.numTitulo}) FALHOU: ${falha.erro}. Os itens dessa parte e das seguintes não foram gravados.`, 'erro');
        } else {
          this.abrirAlerta(`Pedido dividido em ${gravadas.length} pedidos: ${lista}.`, 'sucesso');
          this._resetar();
          setTimeout(() => this.voltarLista.emit(), 2500);
        }
        return;
      }

      if (sankhyaBody?.sucesso === true || sankhyaBody?.sucesso === 'true') {
        const nunota = sankhyaBody?.nunota ?? '';
        let mensagem = `Pedido de Compra gravado! NUNOTA: ${nunota}`;
        if (isCriacao) {
          const buckets: any[] = res?.aerosysBuckets ?? [];
          if (res?.aerosysOk === false) {
            const erros = buckets.filter(b => b?.ok === false).map(b => `${b?.tipo}: ${b?.erro}`);
            mensagem += erros.length
              ? ` (aviso: não foi possível espelhar no Aerosys — ${erros.join(' | ')})`
              : ' (aviso: não foi possível espelhar este pedido no Aerosys — o Sankhya já está gravado normalmente.)';
          } else if (buckets.length > 1 && buckets.every(b => b?.ok)) {
            mensagem += ` (espelhado no Aerosys em ${buckets.length} pedidos: ${buckets.map(b => `${b.tipo} #${b.pcrId}`).join(', ')})`;
          }
        }
        if (!isCriacao && (res?.aerosysSyncOk === false || res?.aerosysSyncCabecalhoOk === false)) {
          mensagem += ` (aviso: não foi possível atualizar no Aerosys — ${res?.aerosysSyncCabecalhoErro ?? res?.aerosysSyncErro ?? 'erro desconhecido'})`;
        }
        this.abrirAlerta(mensagem, 'sucesso');
        this._resetar();
        setTimeout(() => this.voltarLista.emit(), 1500);
      } else {
        const erro = sankhyaBody?.erro ?? res?.statusMessage ?? 'Erro desconhecido ao gravar.';
        this.abrirAlerta(erro, 'erro');
      }
    } catch (err: any) {
      const msg = err?.error?.detail ?? err?.error?.statusMessage ?? err?.error?.message ?? err?.message ?? 'Erro ao gravar pedido.';
      this.abrirAlerta(msg, 'erro');
    } finally {
      this.salvando.set(false);
    }
  }

  // ── Carregar para edição ────────────────────────────────────
  async carregarParaEdicao(nunota: number): Promise<void> {
    this.carregandoEdicao = true;
    try {
      const res: any = await firstValueFrom(this.gateway.buscarDetalhesPedidoVenda(nunota));
      const body     = res?.responseBody ?? res;
      const d        = body?.sucesso ? (body.detalhe ?? body) : null;
      if (!d) {
        console.error('[PedidoCompra] doBuscarDetalhesPedido falhou', nunota, res);
        const det = body?.erro || body?.mensagem || '';
        this.abrirAlerta('Pedido não encontrado para edição.' + (det ? ' Detalhe: ' + det : ''), 'erro');
        return;
      }

      if (d.dtmovIso)        this.dataEmissao              = d.dtmovIso;
      if (d.dtpreventIso)    this.dtPrevent                = d.dtpreventIso;
      if (d.codvend != null) this.compradorSelecionado      = d.codvend;
      if (d.codtipvenda)     this.tipoNegociacaoSelecionado = d.codtipvenda;
      if (d.codnat != null)    this.naturezaSelecionada          = d.codnat;
      if (d.codcencus != null) this.centroResultadoSelecionado   = d.codcencus;
      if (d.codproj != null)   this.projetoSelecionado            = d.codproj;
      if (d.observacao != null) this.observacao = d.observacao;
      if (d.obsInterna != null) this.observacaoInterna = d.obsInterna;
      if (d.numPedido2 != null) this.numPedido2 = d.numPedido2;
      if (d.prioridade) this.prioridadeSelecionada = d.prioridade;
      if (d.vendasDe)  this.qtdeVendidaDtDe  = d.vendasDe;
      if (d.vendasAte) this.qtdeVendidaDtAte = d.vendasAte;
      if (d.gplEmpresaVirtual != null && Number(d.gplEmpresaVirtual) > 0) {
        this.empresaState.selecionada = String(d.gplEmpresaVirtual);
      }
      if (d.tipoGpl != null) this.tipoGpl = d.tipoGpl;
      if (d.gplStatus != null) this.gplStatusAtual = d.gplStatus;
      this.vinculoAerosysId = Number(d.pcrIdAerosys) > 0 ? Number(d.pcrIdAerosys) : 0;

      if (d.vlrMoeda && Number(d.vlrMoeda) > 0) {
        const taxa = Number(d.vlrMoeda);
        this.cotacaoTexto      = taxa.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 4 });
        this.cotacaoSelecionada = { valor: String(taxa), data: '' } as any;
      }

      if (d.codparc && d.cliente) {
        try {
          const resCli: any = await firstValueFrom(
            this.gateway.buscarFornecedorPedidoCompra(String(d.codparc))
          );
          const bodyCli = resCli?.responseBody ?? resCli;
          const lista: FornecedorSugestao[] = bodyCli?.lista ?? [];
          const found = lista.find((c: any) => String(c.codparc) === String(d.codparc));
          const obj: FornecedorSugestao = found ?? { codparc: d.codparc, nomeparc: d.cliente, docparc: d.docparc ?? '' };
          this.fornecedorSelecionado = obj;
          this.fornecedorBusca       = this._montarTextoFornecedor(obj);
          this._recalcularTitulosFornecedor(obj);
        } catch {
          this.fornecedorSelecionado = { codparc: d.codparc, nomeparc: d.cliente };
          this.fornecedorBusca       = this._montarTextoFornecedor(this.fornecedorSelecionado);
          this._recalcularTitulosFornecedor(this.fornecedorSelecionado);
        }
      }

      if (Array.isArray(d.itens) && d.itens.length > 0) {
        let nextId = 1;
        const taxa = this.cotacaoValorNumerico;
        this.itens = d.itens.map((it: any) => {
          const precoUsd  = Number(it.precoUsd) || Number(it.vlrunitmoe) || 0;
          const vlrunit   = Number(it.vlrunit) || 0;
          const item: ItemCompra = {
            id:             nextId++,
            codprod:        it.refforn ?? it.referencia ?? String(it.codprod ?? ''),
            codprodOriginal: it.refforn ?? it.referencia ?? String(it.codprod ?? ''),
            codprodInterno: Number(it.codprod),
            descricao:      it.descricao ?? '',
            unidade:        it.codvol ?? 'UN',
            quantidade:     Number(it.qtd ?? it.qtdneg) || 1,
            precoUsd:       precoUsd > 0 ? precoUsd : (taxa > 0 && vlrunit > 0 ? parseFloat((vlrunit / taxa).toFixed(2)) : 0),
            precoUsdStr:    '',
            obs:            String(it.obsItem ?? ''),
            precoUnitario:  vlrunit,
            // Arredondado pra 2 casas só pra exibição (mesmo ajuste do Pedido
            // de Venda) — o vlrDesc exato na linha abaixo continua intacto.
            desconto:       Math.round((Number(it.percdesc) || 0) * 100) / 100,
            vlrDesc:        Number(it.vlrdesc) || 0,
            vlrAcrescDesc:  Number(it.vlracrescdesc) || 0,
            total:          Number(it.vlrtot) || 0,
            totalUsd:       0,
            estoque:        0,
            codlocalpadrao: Number(it.codlocal) || 0,
            localSel:       Number(it.codlocal) > 0 ? Number(it.codlocal) : undefined,
            statusItem:     (['ABERTO', 'CANCELADO', 'COMPRADO', 'PARCIAL'].includes(String(it.statusItem).toUpperCase())
              ? String(it.statusItem).toUpperCase()
              : 'ABERTO') as ItemCompra['statusItem'],
            idItemAerosys:  Number(it.idItemAerosys) > 0 ? Number(it.idItemAerosys) : undefined,
          };
          item.precoUsdStr = item.precoUsd > 0 ? this.fmtMoeda(item.precoUsd) : '';
          this._calcularTotal(item);
          this._atualizarEstoque(item);
          this._resolverNacional(item); // só marca o flag (R$ mestre); não altera o preço gravado
          return item;
        });
        this._proximoId = nextId + 1;
        this.onFiltroQtdeVendidaMudou();
        for (const it of this.itens) void this._carregarLocaisItem(it);
      }
    } catch (err: any) {
      this.abrirAlerta('Erro ao carregar pedido: ' + (err?.message ?? ''), 'erro');
    } finally {
      this.carregandoEdicao = false;
    }
  }

  // ── Inicialização ───────────────────────────────────────────
  constructor(
    private readonly gateway: SankhyaGatewayService,
    readonly empresaState: EmpresaStateService,
    private readonly produtoService: ProdutoService,
  ) {}

  ngOnInit(): void {
    this._subEmpresaMudou = this.empresaState.empresaMudou.subscribe(() => this._recarregarLocaisDosItens());
    if (this.nunotaEditar != null) {
      this.nunotaAtual = this.nunotaEditar as number;
      this.modoEdicao  = true;
    }

    if (!this.modoEdicao) {
      this.dataEmissao = new Date().toISOString().substring(0, 10);
      this._proximoId  = 1;
      this.itens       = [this._novoItem()];
    }

    this._carregarCompradores();
    this._carregarTiposNegociacao();
    this._carregarNaturezas();
    this._carregarCentrosResultado();
    this._carregarProjetos();
    this._carregarCotacoes();
    this._carregarOpcoesTipoGpl();
    this._carregarDescricaoTop();

    this._qtdeVendidaSubject.pipe(debounceTime(600))
      .subscribe(() => this.buscarQtdeVendida());

    if (this.modoEdicao && this.nunotaEditar != null) {
      this.carregarParaEdicao(this.nunotaEditar as number);
    } else {
      this._carregarFornecedorPadrao();
    }
  }

  /** Fornecedor padrao em pedido NOVO (agiliza a geracao): codparc 7715. O usuario pode trocar ou remover. */
  private readonly FORNECEDOR_PADRAO = '7715';

  private async _carregarFornecedorPadrao(): Promise<void> {
    try {
      const res: any = await firstValueFrom(this.gateway.buscarFornecedorPedidoCompra(this.FORNECEDOR_PADRAO));
      const body = res?.responseBody ?? res;
      const lista: FornecedorSugestao[] = body?.lista ?? [];
      const f = lista.find((x: any) => String(x.codparc) === this.FORNECEDOR_PADRAO);
      // Nao sobrescreve se o usuario ja escolheu outro fornecedor enquanto carregava.
      if (f && !this.fornecedorSelecionado && !this.modoEdicao) this.selecionarFornecedor(f, false);
    } catch { /* sem padrao: usuario escolhe manualmente */ }
  }

  // ── Carga inicial ───────────────────────────────────────────

  /** Troca do TIPO: atualiza a descrição da TOP (1323/1300) exibida. */
  aoMudarTipoGpl(): void {
    this._carregarDescricaoTop();
    this._sincronizarEmpresaComTipo();
  }

  /** Empresa da IMPORTAÇÃO (Aero LLC, fictícia). Ao escolher TIPO = IMPORTAÇÃO a empresa
   *  selecionada vira a 12 (guardando a anterior); ao voltar a NACIONAL, retorna à anterior.
   *  Se já estiver na 12, nada muda. Não atua em modo edição. */
  private readonly EMPRESA_IMPORTACAO = '12';
  private _empresaAntesImportacao: string | null = null;

  private _sincronizarEmpresaComTipo(): void {
    // Pedido de Compra NÃO troca de empresa pelo tipo (isso vale só na Pré-Compra).
  }


  /** Nome real da TOP (TGFTOP.DESCROPER) -- ver comentário em COD_TIP_OPER. */
  private async _carregarDescricaoTop(): Promise<void> {
    try {
      const res: any = await firstValueFrom(this.gateway.buscarDescricaoTop(this.COD_TIP_OPER));
      const body = res?.responseBody ?? res;
      if (body?.sucesso && body?.descricao) {
        this.descricaoTop = body.descricao;
      }
    } catch {
      // Mantém o fallback ('Compra') -- não é crítico pra tela funcionar.
    }
  }

  /** Opções de GPL_TIPO (NACIONAL/IMPORTAÇÃO) via
   *  CampoOpcoesComponentSP.doBuscarOpcoes -- mesmo endpoint genérico já
   *  usado na Venda. Em modo criação, prioriza IMPORTAÇÃO como padrão. */
  private async _carregarOpcoesTipoGpl(): Promise<void> {
    try {
      const res: any = await firstValueFrom(this.gateway.buscarOpcoesCampoPedidoVenda('TGFCAB', 'GPL_TIPO'));
      const body      = res?.responseBody ?? res;
      const opcoes: OpcaoCampo[] = (body?.opcoes ?? []).map((o: any) =>
        typeof o === 'string' ? { valor: o, opcao: o } : { valor: o.valor ?? o, opcao: o.opcao ?? o.valor ?? o }
      );

      if (body?.sucesso && Array.isArray(opcoes) && opcoes.length > 0) {
        this.tipoGplOpcoes = opcoes;
        if (!this.modoEdicao && !this._tipoDefinidoPorFornecedor) {
          const importacao = opcoes.find(o => o.valor === 'IMPORTACAO');
          this.tipoGpl = importacao ? importacao.valor : (opcoes[0]?.valor ?? 'IMPORTACAO');
          this._sincronizarEmpresaComTipo();
        }
      }
    } catch { }
  }

  /** Rótulo exibido pro combo GPL_TIPO -- não usa o texto (`opcao`) vindo do
   *  banco porque o TDDOPC.OPCAO desse campo está gravado com encoding
   *  quebrado ("IMPORTAÇÃO" virou lixo/mojibake). O `valor` (código, sem
   *  acento) não tem esse problema, então montamos o rótulo localmente. */
  labelTipoGpl(valor: string): string {
    if (valor === 'IMPORTACAO') return 'IMPORTAÇÃO';
    if (valor === 'NACIONAL')   return 'NACIONAL';
    return valor;
  }

  private async _carregarCompradores(): Promise<void> {
    try {
      // TIPVEND IN ('C','V','G') -- comprador, vendedor e gerente.
      const res: any = await firstValueFrom(this.gateway.buscarVendedoresPedidoVenda({ tipVend: 'C,V,G' }));
      const body     = res?.responseBody ?? res;
      if (body?.sucesso && Array.isArray(body.vendedores)) {
        this.compradores = body.vendedores;
      }
    } catch { }

    if (!this.modoEdicao) {
      let codVendPadrao: string | number | null = null;
      try {
        const res: any = await firstValueFrom(this.gateway.buscarVendedorLogadoPedidoVenda());
        const body     = res?.responseBody ?? res;
        // Só usa o vendedor logado como comprador padrão se ele realmente
        // estiver na lista de compradores (TIPVEND='C') -- senão o campo
        // ficaria com um código selecionado que não aparece nas opções.
        // Retorno do addon: { sucesso, vendedor: { codVend, apelido } } ("0" = sem vendedor).
        const vendLogado    = body?.vendedor ?? body ?? {};
        const codVendLogado = Number(vendLogado?.codVend) > 0 ? vendLogado.codVend : null;
        if (codVendLogado != null) {
          // O vendedor do usuário logado vira o solicitante padrão mesmo que o cadastro dele
          // (TGFVEN) não seja dos tipos listados (C/V/G): entra na lista pra poder ser exibido.
          if (!this.compradores.some(v => String(v.codVend) === String(codVendLogado))) {
            this.compradores = [...this.compradores, { codVend: codVendLogado, apelido: vendLogado?.apelido ?? String(codVendLogado) }];
          }
          codVendPadrao = codVendLogado;
        }
      } catch { }

      if (codVendPadrao == null) {
        // Sem vendedor ligado ao usuário: procura na lista de compradores pelo nome do usuário logado.
        const porNome = codVendCompradorDoUsuario(this.compradores);
        if (porNome != null) { codVendPadrao = porNome; }
      }

      if (codVendPadrao == null) {
        // Usuário logado não é comprador (TIPVEND='C') -- cai pro
        // "COMPRADOR" genérico (CODVEND=24), pra facilitar o preenchimento.
        const generico = this.compradores.find(v => String(v.codVend) === '24');
        if (generico) { codVendPadrao = generico.codVend; }
      }

      if (codVendPadrao != null) { this.compradorSelecionado = codVendPadrao; }
    }
  }

  private async _carregarTiposNegociacao(): Promise<void> {
    this.tiposNegociacaoCarregando = true;
    try {
      const res: any = await firstValueFrom(this.gateway.buscarTiposNegociacaoPedidoVenda());
      const body     = res?.responseBody ?? res;
      if (body?.sucesso && Array.isArray(body.tiposVenda)) {
        this.tiposNegociacao = body.tiposVenda
          .filter((t: any) => !!t?.descricao && String(t.descricao).trim().length > 0)
          .sort((a: any, b: any) => String(a.descricao).localeCompare(String(b.descricao)));
      }
    } catch { }
    finally { this.tiposNegociacaoCarregando = false; }
  }

  private async _carregarNaturezas(): Promise<void> {
    this.naturezasCarregando = true;
    try {
      const res: any = await firstValueFrom(this.gateway.buscarNaturezasPedidoVenda());
      const body     = res?.responseBody ?? res;
      const lista    = body?.naturezas ?? [];
      if (body?.sucesso !== false && Array.isArray(lista) && lista.length > 0) {
        const itens = lista
          .filter((n: any) => !!n?.descricao && String(n.descricao).trim().length > 0)
          .sort((a: any, b: any) => String(a.descricao ?? '').localeCompare(String(b.descricao ?? '')));
        const temZero = itens.some((n: any) => String(n.codNat) === '0');
        if (!temZero) itens.unshift({ codNat: '0', descricao: 'Nenhuma' });
        this.naturezas = itens;
      }
    } catch { }
    finally { this.naturezasCarregando = false; }
  }

  private async _carregarCentrosResultado(): Promise<void> {
    this.centrosResultadoCarregando = true;
    try {
      const res: any = await firstValueFrom(this.gateway.buscarCentrosResultadoPedidoVenda());
      const body     = res?.responseBody ?? res;
      const lista    = body?.centros ?? [];
      if (body?.sucesso !== false && Array.isArray(lista) && lista.length > 0) {
        const itens = lista
          .filter((c: any) => !!c?.descricao && String(c.descricao).trim().length > 0)
          .sort((a: any, b: any) => String(a.descricao ?? '').localeCompare(String(b.descricao ?? '')));
        const temZero = itens.some((c: any) => String(c.codCen) === '0');
        if (!temZero) itens.unshift({ codCen: '0', descricao: 'Nenhum' });
        this.centrosResultado = itens;
      }
    } catch { }
    finally { this.centrosResultadoCarregando = false; }
  }

  private async _carregarProjetos(): Promise<void> {
    this.projetosCarregando = true;
    try {
      const res: any = await firstValueFrom(this.gateway.buscarProjetosPedidoVenda());
      const body     = res?.responseBody ?? res;
      const lista    = body?.projetos ?? [];
      if (body?.sucesso !== false && Array.isArray(lista) && lista.length > 0) {
        const itens = lista
          .filter((p: any) => !!p?.descricao && String(p.descricao).trim().length > 0)
          .sort((a: any, b: any) => String(a.descricao ?? '').localeCompare(String(b.descricao ?? '')));
        const temZero = itens.some((p: any) => String(p.codProj) === '0');
        if (!temZero) itens.unshift({ codProj: '0', descricao: 'Nenhum' });
        this.projetos = itens;
      }
    } catch { }
    finally { this.projetosCarregando = false; }
  }

  private async _carregarCotacoes(): Promise<void> {
    this.cotacaoCarregando = true;
    try {
      const res: any = await firstValueFrom(this.gateway.buscarCotacoesDemonstrativo());
      const body     = res?.responseBody ?? res;
      const cotacoes = body?.cotacoes ?? [];
      if (body?.sucesso !== false && Array.isArray(cotacoes)) {
        this.cotacoesDisponiveis = cotacoes;
        if (!this.cotacaoTexto && cotacoes.length > 0) {
          this.cotacaoSelecionada = cotacoes[0];
          this.cotacaoTexto       = this._fmtCotacao(cotacoes[0]);
        }
      }
    } catch { }
    finally { this.cotacaoCarregando = false; }
  }

  // ── Busca de Fornecedor ────────────────────────────────────
  onFornecedorInput(event?: Event): void {
    if (this.fornecedorSelecionado) {
      // Fornecedor já preenchido automaticamente ("CÓDIGO - Nome | ..."): o usuário continua digitando o código,
      // então vale só o trecho antes do primeiro " - " (igual ao campo Fabricante do cadastro de produto).
      this._fornecedorAnterior        = this.fornecedorSelecionado;
      this.fornecedorSelecionado      = null;
      const digitado = ((event?.target as HTMLInputElement | undefined)?.value ?? this.fornecedorBusca) || '';
      const idx = digitado.indexOf(' - ');
      this.fornecedorBusca            = (idx >= 0 ? digitado.substring(0, idx) : digitado).trim();
      this.titulosFornecedorPosicionados = [];
    }
    clearTimeout(this._fornecedorTimer);
    const termo = this.fornecedorBusca.trim();
    if (termo.length < 2 && !/^\d+$/.test(termo)) { this.fornecedorSugestoes = []; this.mostrarDropdownFornecedor = false; return; }
    this.mostrarDropdownFornecedor = true;
    this._fornecedorTimer = setTimeout(() => this._buscarFornecedor(termo), /^\d+$/.test(termo) ? 250 : 350);
  }

  onFornecedorFocus(): void {
    if (this.fornecedorSelecionado) {
      this._fornecedorAnterior        = this.fornecedorSelecionado;
      this.fornecedorSelecionado      = null;
      this.fornecedorBusca            = '';
      this.fornecedorSugestoes        = [];
      this.titulosFornecedorPosicionados = [];
      this.mostrarDropdownFornecedor  = false;
    }
  }

  onFornecedorBlur(): void {
    setTimeout(() => {
      this.mostrarDropdownFornecedor = false;
      if (!this.fornecedorSelecionado) {
        if (this.fornecedorBusca.trim() && this.fornecedorSugestoes.length > 0) {
          this.selecionarFornecedor(this.fornecedorSugestoes[0]);
        } else if (!this.fornecedorBusca.trim() && this._fornecedorAnterior) {
          this.fornecedorSelecionado = this._fornecedorAnterior;
          this.fornecedorBusca       = this._montarTextoFornecedor(this._fornecedorAnterior);
          this._recalcularTitulosFornecedor(this._fornecedorAnterior);
        }
      }
      this._fornecedorAnterior = null;
    }, 200);
  }

  private async _buscarFornecedor(termo: string): Promise<void> {
    this.fornecedorCarregando = true;
    try {
      const res: any  = await firstValueFrom(this.gateway.buscarFornecedorPedidoCompra(termo));
      const body      = res?.responseBody ?? res;
      this.fornecedorSugestoes = ordenarSugestoesParceiro(body?.lista ?? [], termo);
      // Código digitado inteiro e igual ao de um fornecedor: já preenche os dados, sem esperar sair do campo.
      if (/^\d+$/.test(termo) && !this.fornecedorSelecionado && this.fornecedorBusca.trim() === termo) {
        const exato = this.fornecedorSugestoes.find(f => String(f.codparc) === termo);
        if (exato) {
          this.selecionarFornecedor(exato);
          // Mantém o cursor logo após o código, para continuar digitando sem misturar com o nome.
          setTimeout(() => {
            const el = document.getElementById('pcf-fornecedor-input') as HTMLInputElement | null;
            if (el && document.activeElement === el) el.setSelectionRange(termo.length, termo.length);
          });
        }
      }
    } catch { this.fornecedorSugestoes = []; }
    finally { this.fornecedorCarregando = false; }
  }

  /** Evita que o padrão IMPORTAÇÃO (carregado depois) sobrescreva o TIPO já definido pela UF do fornecedor. */
  private _tipoDefinidoPorFornecedor = false;

  selecionarFornecedor(f: FornecedorSugestao, definirTipoPelaUf = true): void {
    // TIPO pelo endereço do fornecedor ao TROCAR de fornecedor: UF "EX" (exterior) = IMPORTAÇÃO; outra UF = NACIONAL.
    // O fornecedor padrão que já abre preenchido (7715) não altera o TIPO.
    const uf = (f.uf ?? '').toString().trim().toUpperCase();
    if (definirTipoPelaUf && uf) {
      this.tipoGpl = uf === 'EX' ? 'IMPORTACAO' : 'NACIONAL';
      this._tipoDefinidoPorFornecedor = true;
      this._carregarDescricaoTop();
      this._sincronizarEmpresaComTipo();
    }
    this._fornecedorAnterior   = null;
    this.fornecedorSelecionado = f;
    this.fornecedorBusca       = this._montarTextoFornecedor(f);
    this.mostrarDropdownFornecedor = false;
    this.fornecedorSugestoes   = [];
    this._recalcularTitulosFornecedor(f);
  }

  removerFornecedor(): void {
    this._fornecedorAnterior        = null;
    this.fornecedorSelecionado      = null;
    this.fornecedorBusca            = '';
    this.fornecedorSugestoes        = [];
    this.titulosFornecedorPosicionados = [];
  }

  // Busca modal (lupa)
  async abrirModalFornecedor(): Promise<void> {
    this.filtroFornecedorModal    = '';
    this.fornecedorModalLista     = [];
    this.fornecedorModalAberta    = true;
    await this._buscarFornecedorModal('');
  }

  fecharModalFornecedor(): void { this.fornecedorModalAberta = false; }

  onFiltroFornecedorModalChange(): void {
    clearTimeout(this._fornecedorModalTimer);
    this._fornecedorModalTimer = setTimeout(() =>
      this._buscarFornecedorModal(this.filtroFornecedorModal), 350);
  }

  private async _buscarFornecedorModal(termo: string): Promise<void> {
    this.fornecedorModalCarregando = true;
    try {
      const res: any = await firstValueFrom(
        this.gateway.buscarFornecedorPedidoCompra(termo || 'a')
      );
      const body = res?.responseBody ?? res;
      this.fornecedorModalLista = body?.lista ?? [];
    } catch { this.fornecedorModalLista = []; }
    finally { this.fornecedorModalCarregando = false; }
  }

  selecionarFornecedorModal(f: FornecedorSugestao): void {
    this.selecionarFornecedor(f);
    this.fornecedorModalAberta = false;
  }

  // ── Tipo Negociação modal ───────────────────────────────────
  abrirBuscaTipoNegociacao(): void {
    this.filtroTipoNegociacao    = '';
    this.tipoNegociacaoModalAberta = true;
    this._carregarTiposNegociacao();
  }
  fecharBuscaTipoNegociacao(): void { this.tipoNegociacaoModalAberta = false; }
  selecionarTipoNegociacao(t: { codTipVenda: string | number; descricao: string }): void {
    this.tipoNegociacaoSelecionado = t.codTipVenda;
    this.tipoNegociacaoModalAberta = false;
  }
  limparTipoNegociacao(): void { this.tipoNegociacaoSelecionado = ''; }

  // ── Comprador modal ─────────────────────────────────────────
  abrirBuscaComprador(): void { this.filtroComprador = ''; this.compradorModalAberta = true; }
  fecharBuscaComprador(): void { this.compradorModalAberta = false; }
  selecionarComprador(v: VendedorOpcao): void {
    this.compradorSelecionado  = v.codVend;
    this.compradorModalAberta  = false;
  }
  limparComprador(): void { this.compradorSelecionado = null; }

  // ── Helpers ─────────────────────────────────────────────────
  private _montarTextoFornecedor(f: FornecedorSugestao): string {
    const nomeComCodigo = f.codparc ? `${f.codparc} - ${f.nomeparc}` : f.nomeparc;
    const extras: string[] = [];
    if (f.docparc)      extras.push(this.fmtDocumento(f.docparc));
    if (f.inscEstadual) extras.push(this.fmtIE(f.inscEstadual));
    return extras.length > 0 ? `${nomeComCodigo}   |   ${extras.join('   |   ')}` : nomeComCodigo;
  }

  private _recalcularTitulosFornecedor(f: FornecedorSugestao | null): void {
    if (!f) { this.titulosFornecedorPosicionados = []; return; }
    if (!this._fornecCanvasCtx) {
      const canvas = document.createElement('canvas');
      this._fornecCanvasCtx = canvas.getContext('2d');
    }
    const ctx = this._fornecCanvasCtx;
    if (!ctx) { this.titulosFornecedorPosicionados = []; return; }
    ctx.font = this.FORNEC_INPUT_FONT;

    const campos: { label: string; valor?: string; display?: string }[] = [
      { label: 'CNPJ/CPF',      valor: f.docparc,      display: this.fmtDocumento(f.docparc) },
      { label: 'INSC. ESTADUAL', valor: f.inscEstadual,  display: this.fmtIE(f.inscEstadual) },
    ];

    const nomeComCodigo = f.codparc ? `${f.codparc} - ${f.nomeparc}` : f.nomeparc;
    let offset = this.FORNEC_INPUT_TEXT_START_PX + ctx.measureText(nomeComCodigo).width;
    const titulos: { label: string; left: number }[] = [];

    for (const campo of campos) {
      if (!campo.valor || !String(campo.valor).trim()) continue;
      offset += ctx.measureText('   |   ').width;
      titulos.push({ label: campo.label, left: offset });
      offset += ctx.measureText(String(campo.display ?? campo.valor)).width;
    }

    this.titulosFornecedorPosicionados = titulos;
  }

  fmtDocumento(doc: string | null | undefined): string {
    const d = (doc ?? '').replace(/\D/g, '');
    if (d.length === 14) return d.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
    if (d.length === 11) return d.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
    return doc || '';
  }

  fmtIE(ie: string | null | undefined): string {
    const d = (ie ?? '').replace(/\D/g, '');
    if (d.length === 12) return d.replace(/^(\d{3})(\d{3})(\d{3})(\d{3})$/, '$1.$2.$3.$4');
    if (d.length === 10) return d.replace(/^(\d{3})(\d{5})(\d{2})$/, '$1.$2-$3');
    if (d.length === 9)  return d.replace(/^(\d{3})(\d{3})(\d{3})$/, '$1.$2.$3');
    if (d.length === 8)  return d.replace(/^(\d{2})(\d{3})(\d{2})(\d{1})$/, '$1.$2.$3-$4');
    return ie || '';
  }

  fmtDecimal(n: number): string {
    return n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 4 });
  }

  fmtMoeda(n: number): string {
    return n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  /** digitsInfo do pipe "number" para qualquer campo de quantidade/estoque com
   *  base na unidade do produto (mesma lógica usada em Pedido de Venda e
   *  Consulta de Peças). UN nunca tem fração (não dá pra comprar "meia
   *  peça"), então mostra inteiro; unidades fracionárias (M, KG, L, etc.)
   *  continuam mostrando até 3 casas decimais. */
  casasDecimaisQtd(unidade: string | null | undefined, valor?: number | string | null): string {
    // "valor" às vezes chega como string (ex.: BigDecimal serializado como "2.000"
    // pelo backend) em vez de number — Number.isInteger('2.000') sempre retorna
    // false para string, mesmo o valor sendo inteiro, então isso derrubava pro
    // fallback por unidade e voltava a mostrar ".000". Convertendo com Number(...)
    // e tolerando resíduo de ponto flutuante (ex.: 1.9999999999998 vindo de SUM()
    // no Oracle) cobre os dois casos.
    if (valor != null && valor !== '') {
      const num = typeof valor === 'string' ? Number(valor.replace(',', '.')) : valor;
      if (Number.isFinite(num) && Math.abs(num - Math.round(num)) < 1e-6) {
        return '1.0-0';
      }
    }
    const un = String(unidade ?? 'UN').trim().toUpperCase();
    return un === 'UN' ? '1.0-0' : '1.0-3';
  }

  /** digitsInfo do painel "Estoque por Local" — usa a unidade do produto
   *  selecionado na busca de peças (F3). */
  casasDecimaisEstoqueLocal(valor?: number | string | null): string {
    return this.casasDecimaisQtd(this.buscaPecasProdutoSelecionado?.codvol, valor);
  }

  // ── Alerta ──────────────────────────────────────────────────
  abrirAlerta(mensagem: string, tipo: 'sucesso' | 'erro' | 'aviso'): void {
    this.alerta = { mensagem, tipo };
    setTimeout(() => this.alerta = null, 5000);
  }

  // ── Reset ───────────────────────────────────────────────────
  /** Converte data de ISO (YYYY-MM-DD) para o formato esperado pelo backend Oracle (DD/MM/YYYY). */
  private _isoToBr(iso: string | null | undefined): string {
    if (!iso) return '';
    const parts = iso.split('-');
    if (parts.length !== 3) return iso;
    return `${parts[2]}/${parts[1]}/${parts[0]}`;
  }

  private _resetar(): void {
    this._proximoId  = 1;
    this.itens       = [this._novoItem()];
    this.observacao  = '';
    this.observacaoInterna = '';
    this.numPedido2  = '';
    this.fornecedorSelecionado        = null;
    this.fornecedorBusca              = '';
    this.titulosFornecedorPosicionados = [];
    this.mudarAba('dados');
    this.modoEdicao  = false;
    this.nunotaAtual = null;
    this.gplStatusAtual = '';
    this.vinculoAerosysId = 0;
    this.compradorSelecionado = null;
    this.prioridadeSelecionada = 'NORMAL';
    this.tipoGpl = 'IMPORTACAO';
    this.tipoNegociacaoSelecionado  = '3';
    this.naturezaSelecionada        = '3010101';
    this.centroResultadoSelecionado = '201000';
    this.projetoSelecionado         = '1000000000';
    this.dataEmissao = new Date().toISOString().substring(0, 10);
    this.dtPrevent   = '';
    this._carregarFornecedorPadrao();
  }
}
